<template>
  <div>
    <v-container fluid class="px-15">
      <!-- Spinner de carga -->
      <v-overlay :value="isLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <!-- Contenido -->
      <template v-if="!isLoading">
        <div style="position: absolute;">
          <v-btn @click="$router.go(-1)" text class="pl-0">
            <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
            <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
          </v-btn>
        </div>
        <v-row class="mt-6" style="align-items: center;">
          <v-col>
            <h1 class="mb-3" style="font-family: 'montserrat-bold'; color: black; font-size: 32px; text-wrap: nowrap;">{{ enterprise.enterprise.enterprise[0].sName }}</h1>
          </v-col>
        </v-row>
        <v-row class="mt-2" justify="center" style="align-items: flex-end;">
          <v-col>
            <v-card class="info-card">
              <div class="info-block mb-0">
                <p class="label">Id:</p>
                <p class="value">{{ enterprise.enterprise.sSubAccountId }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <div style="display: flex; justify-content: space-between;">
                  <p class="label">Wallet USD</p>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" @click="openModalAddFounds('USD')" icon text>
                        <v-icon color="black">mdi-account-details</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ "Detalle de cuenta" }}</span> 
                  </v-tooltip>
                </div>
                <p class="value" style="text-wrap: nowrap;">{{ "$" + formatMoney(enterprise.balance?.balanceUsd?.balance) + " USD" }}</p>
                <p class="label">Blocked Amount</p>
                <p class="value">{{ "$" + formatMoney(enterprise.balance?.blocked?.balance) + " USD" }}</p>
              </div>
              <div class="info-block mb-0">
                <div style="display: flex; justify-content: space-between;">
                  <p class="label">Wallet MXN</p>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" @click="openModalAddFounds('MXN')" icon text>
                        <v-icon color="black">mdi-account-details</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ "Detalle de cuenta" }}</span> 
                  </v-tooltip>
                </div>
                <p class="value" style="text-wrap: nowrap;">{{ "$" + formatMoney(enterprise.balance?.balanceMxn?.balance) + " MXN" }}</p>
                <p class="label">Blocked Amount</p>
                <p class="value">{{ "$" + formatMoney(enterprise.balance?.blockedMXN?.balance) + " MXN" }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <div style="display: flex; align-items: center; gap: 4px;">
                  <p class="label" style="margin: 0;">Tipo de cambio (Venta):</p>
                  <v-tooltip v-if="spreadValidation.configuredSpread !== null" bottom max-width="320">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon :color="spreadValidation.valid === false ? 'red' : 'grey'" size="16" v-bind="attrs" v-on="on">
                        {{ spreadValidation.valid === false ? 'mdi-alert-circle' : 'mdi-information-outline' }}
                      </v-icon>
                    </template>
                    <span>
                      <strong>Mid-market (EFEX):</strong> ${{ spreadValidation.midRate }} MXN<br>
                      <strong>Spread real (Venta):</strong> {{ spreadValidation.impliedSpreadVenta }}%<br>
                      <strong>Spread configurado:</strong> {{ spreadValidation.configuredSpread }}%
                    </span>
                  </v-tooltip>
                </div>
                <p class="value" :style="spreadValidation.valid === false ? 'color: #e53935;' : ''">
                  {{ "$" + formatMoney(enterprise.exchangeRate.mxnRate) + " MXN" }}
                </p>
              </div>
              <div class="info-block mb-0">
                <div style="display: flex; align-items: center; gap: 4px;">
                  <p class="label" style="margin: 0;">Tipo de cambio (Compra):</p>
                  <v-tooltip v-if="spreadValidation.configuredSpread !== null" bottom max-width="320">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon :color="spreadValidation.valid === false ? 'red' : 'grey'" size="16" v-bind="attrs" v-on="on">
                        {{ spreadValidation.valid === false ? 'mdi-alert-circle' : 'mdi-information-outline' }}
                      </v-icon>
                    </template>
                    <span>
                      <strong>Mid-market (EFEX):</strong> ${{ spreadValidation.midRate }} MXN<br>
                      <strong>Spread real (Compra):</strong> {{ spreadValidation.impliedSpreadCompra }}%<br>
                      <strong>Spread configurado:</strong> {{ spreadValidation.configuredSpread }}%
                    </span>
                  </v-tooltip>
                </div>
                <p class="value" :style="spreadValidation.valid === false ? 'color: #e53935;' : ''">
                  {{ "$" + formatMoney(enterprise.exchangeRate.usdRate) + " MXN" }}
                </p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Spread:</p>
                <p class="value">{{ "." + (enterprise.enterprise.spread * 100).toFixed(2).replace(/\.?0+$/, '') + " %" }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Revenue:</p>
                <p class="value">{{ "-" }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <div style="display: flex; width: 100%; justify-content: flex-end;"> 
              <v-btn
                class="my-4 py-5 px-8"
                elevation="8"
                color="black"
                rounded
                @click="openModalAccountStatment"
              >
                <span  style="font-family: 'montserrat-semibold'; color: white">{{ "Estado de cuenta" }}</span>
              </v-btn>
            </div>
            <v-card class="info-card">
              <div class="info-block mb-0">
                <p class="label" style="font-weight: bold; margin-bottom: 12px;">Cuentas activas</p>
                <div class="account-row">
                  <div class="account-status">
                    <v-icon :color="activeAccounts.retiro ? 'green' : 'red'" size="20">
                      {{ activeAccounts.retiro ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                    <span class="account-label">Cuenta retiro</span>
                  </div>
                  <v-btn v-if="activeAccounts.retiro" icon x-small @click="openAccountDetail('retiro')">
                    <v-icon size="18" color="grey darken-1">mdi-eye-outline</v-icon>
                  </v-btn>
                </div>
                <div class="account-row">
                  <div class="account-status">
                    <v-icon :color="activeAccounts.mxn ? 'green' : 'red'" size="20">
                      {{ activeAccounts.mxn ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                    <span class="account-label">Cuenta MXN</span>
                  </div>
                  <v-btn v-if="activeAccounts.mxn" icon x-small @click="openAccountDetail('mxn')">
                    <v-icon size="18" color="grey darken-1">mdi-eye-outline</v-icon>
                  </v-btn>
                </div>
                <div class="account-row">
                  <div class="account-status">
                    <v-icon :color="activeAccounts.usd ? 'green' : 'red'" size="20">
                      {{ activeAccounts.usd ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                    <span class="account-label">Cuenta USD</span>
                  </div>
                  <v-btn v-if="activeAccounts.usd" icon x-small @click="openAccountDetail('usd')">
                    <v-icon size="18" color="grey darken-1">mdi-eye-outline</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="my-4" style="justify-content: space-around">
          <v-btn
            class="my-4 mx-4 py-5"
            elevation="8"
            outlined
            :disabled="!company || !permissionList.includes('createWithdrawal')"
            style="width: 204px; border: 2px black solid;"
            rounded
            @click="e1 = 1, dialogWithdrawal = true, supplier = company"
          >
            <v-icon left color="black">mdi-arrow-top-right-thin</v-icon>
            <span style="font-family: 'montserrat-bold';">{{ "Retiro" }}</span>
          </v-btn>
          <v-btn
            class="my-4 mx-4 py-5"
            elevation="8"
            outlined
            :disabled="!permissionList.includes('createPayment')"
            style="width: 204px; border: 2px black solid;"
            rounded
            @click="e1 = 1, dialogSendPay = true, getSuppliers()"
          >
            <v-icon color="black">mdi-arrow-top-right-thin</v-icon>
            <span style="font-family: 'montserrat-bold';">{{ "Send Payment" }}</span>
          </v-btn>
          <!-- <v-btn
            class="my-4 mx-4 py-5"
            elevation="8"
            outlined
            :disabled="!permissionList.includes('createPayment')"
            style="width: 204px; border: 2px black solid;"
            rounded
            @click="openMassPaymentDialog()"
          >
            <v-icon color="black">mdi-file-multiple</v-icon>
            <span style="font-family: 'montserrat-bold';">{{ "Send Mass Payment" }}</span>
          </v-btn> -->
          <v-btn
            class="my-4 mx-4 py-5"
            elevation="8"
            outlined
            style="width: 204px; border: 2px black solid;"
            rounded
            @click="dialogConvert = true"
          >
            <v-icon color="black">mdi-swap-horizontal</v-icon>
            <span style="font-family: 'montserrat-semibold';">{{ "convert" }}</span>
          </v-btn>
          <v-btn
            class="my-4 mx-4 py-5"
            elevation="8"
            outlined
            style="width: 204px; border: 2px black solid;"
            rounded
            @click="dialogSelectAccountType = true"
            :disabled="!permissionList.includes('createBeneficiary')"
          >
            <v-icon color="black">mdi-plus</v-icon>
            <span style="font-family: 'montserrat-semibold';">{{ "Crear Cuenta" }}</span>
          </v-btn>
        </v-row>

        <v-card style="border-radius: 15px; display: flex; justify-content: center; flex-direction: column;">
          <v-tabs style="border-radius: 15px;" dark background-color="dark darken-3" show-arrows v-model="tab">
            <v-tabs-slider color="dark lighten-3"></v-tabs-slider>
            <v-tab href="#info" @click="tab = 'info'">
              Info
            </v-tab>
            <v-tab href="#documents" @click="tab = 'documents'">
              Documents
            </v-tab>
            <v-tab href="#movimientos" @click="tab = 'movimientos'">
              Movimientos
            </v-tab>
            <v-tab href="#spreads" @click="tab = 'spreads'">
              Spreads
            </v-tab>
            <v-tab href="#balances" @click="tab = 'balances'">
              Balances
            </v-tab>
            <v-tab href="#users" @click="tab = 'users'">
              Users
            </v-tab>
            <v-tab href="#modules" @click="tab = 'modules'">
              Modulos
            </v-tab>
            <v-tab href="#permissions" @click="tab = 'permissions'">
              Permisos
            </v-tab>
            <v-tab href="#alerts" @click="tab = 'alerts'">
              Alertas
            </v-tab>
            <v-tab href="#facturas" @click="tab = 'facturas'">
              Facturas PP
            </v-tab>
            <v-tab href="#facturasMX" @click="tab = 'facturasMX'">
              Facturas PC
            </v-tab>
            <v-tab href="#conversionesActivas" @click="tab = 'conversionesActivas'">
              Conversiones Activas
            </v-tab>
            <v-tab href="#conversionesDisponibles" @click="tab = 'conversionesDisponibles'">
              Conversiones Disponibles
            </v-tab>
            <v-tab href="#ingresos" @click="tab = 'ingresos'">
              Ingresos
            </v-tab>
            <v-tab href="#conversiones" @click="tab = 'conversiones'">
              Conversiones
            </v-tab>
            <v-tab href="#egresos" @click="tab = 'egresos'">
              Egresos
            </v-tab>
            <v-tab href="#beneficiarios" @click="tab = 'beneficiarios'">
              Beneficiarios
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item value="users">
              <keep-alive>
                <Users :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" />
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="modules">
              <keep-alive>
                <Modules :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab"/>
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="movimientos">
              <keep-alive>
                <Movimientos :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab"/>
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="spreads">
              <keep-alive>
                <Spreads :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab"/>
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="balances">
              <keep-alive>
                <Balances :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab"/>
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="permissions">
              <keep-alive>
                <Permissions :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" @wallets:update="onWalletsUpdate"/>
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="alerts">
              <keep-alive>
                <Alerts :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" />
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="facturas">
              <keep-alive>
                <Facturas :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" @wallets:update="onWalletsUpdate"/>
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="facturasMX">
              <keep-alive>
                <FacturasMX :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" />
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="conversionesActivas">
              <keep-alive>
                <ConversionesActivas :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" @wallets:update="onWalletsUpdate"/>
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="conversionesDisponibles">
              <keep-alive>
                <ConversionesDisponibles :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" @wallets:update="onWalletsUpdate"/>
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="ingresos">
              <keep-alive>
                <Ingresos :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" />
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="conversiones">
              <keep-alive>
                <Conversions :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" />
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="egresos">
              <keep-alive>
                <Egresos :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" />
              </keep-alive>
            </v-tab-item>
            <v-tab-item value="beneficiarios">
              <keep-alive>
                <Beneficiarios :enterprise="enterprise" :permissionList="permissionList" :active-tab="tab" />
              </keep-alive>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
    </v-container>
    <v-dialog v-if="dialogAddFounds" v-model="dialogAddFounds" persistent max-width="680" class="pa-8">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="title font-weight-bold text-textblack">
            {{ "Detalle de cuenta" }}
          </span>
          <v-btn icon @click="dialogAddFounds = false">
            <v-icon color="#2E404E">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="py-6">
          <v-sheet rounded="lg" color="#F7F8F9" class="pa-13">
            <div v-if="addFoundsCurrency == 'USD'" style="display: flex; gap: 20px;">
              <v-card style="border-radius: 20px;" v-if="!isLoadingFounds">
                <v-card-text>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Beneficiary" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.beneficiary }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Beneficiary Address" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.beneficiary_address }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Bank Name" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.bank_name }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Bank Address" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.bank_address }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between" v-if="dataAddFounds">
                    <div style="font-family: 'montserrat-bold';">{{ "Account Type" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.account_type }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Account Number" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.account_number }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between" v-if="dataAddFounds">
                    <div style="font-family: 'montserrat-bold';">{{ "Routing Code WIRE" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.routing_code[1] }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between" v-if="dataAddFounds">
                    <div style="font-family: 'montserrat-bold';">{{ "Routing Code ACH" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.routing_code[0] }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Swift Code" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.swift_code }}</div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-if="addFoundsCurrency == 'MXN'">
              <v-card style="border-radius: 20px;" width="400px">
                <v-card-text>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Beneficiary" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.beneficiary }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Bank Name" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.bank_name }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "CLABE" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.account_number }}</div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog para detalle de cuentas activas (retiro, MXN, USD) -->
    <v-dialog v-if="dialogAccountDetail" v-model="dialogAccountDetail" persistent max-width="500" class="pa-8">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="title font-weight-bold text-textblack">
            {{ accountDetailType === 'retiro' ? 'Cuenta Retiro' : accountDetailType === 'mxn' ? 'Cuenta MXN' : 'Cuenta USD' }}
          </span>
          <v-btn icon @click="dialogAccountDetail = false, accountDetailData = null">
            <v-icon color="#2E404E">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="py-6">
          <v-sheet rounded="lg" color="#F7F8F9" class="pa-6">
            <div v-if="isLoadingAccountDetail" class="text-center py-4">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
            <v-card v-else-if="accountDetailData" style="border-radius: 20px;">
              <v-card-text>
                <div class="d-flex mb-2" style="justify-content: space-between" v-if="accountDetailData.sName">
                  <div style="font-family: 'montserrat-bold';">{{ "Nombre" }}</div>
                  <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 200px;">{{ accountDetailData.sName }}</div>
                </div>
                <div class="d-flex mb-2" style="justify-content: space-between" v-if="accountDetailData.sBankName">
                  <div style="font-family: 'montserrat-bold';">{{ "Banco" }}</div>
                  <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 200px;">{{ accountDetailData.sBankName }}</div>
                </div>
                <div class="d-flex mb-2" style="justify-content: space-between" v-if="accountDetailData.sAccountNumber">
                  <div style="font-family: 'montserrat-bold';">{{ accountDetailData.sAccountCurrency === 'MXN' ? 'CLABE' : 'Número de cuenta' }}</div>
                  <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 200px;">{{ accountDetailData.sAccountNumber }}</div>
                </div>
                <div class="d-flex mb-2" style="justify-content: space-between" v-if="accountDetailData.accountNumber">
                  <div style="font-family: 'montserrat-bold';">{{ "Cuenta" }}</div>
                  <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 200px;">{{ accountDetailData.accountNumber }}</div>
                </div>
                <div class="d-flex mb-2" style="justify-content: space-between" v-if="accountDetailData.sAccountCurrency">
                  <div style="font-family: 'montserrat-bold';">{{ "Moneda" }}</div>
                  <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 200px;">{{ accountDetailData.sAccountCurrency }}</div>
                </div>
                <div class="d-flex mb-2" style="justify-content: space-between" v-if="accountDetailData.sAccountType">
                  <div style="font-family: 'montserrat-bold';">{{ "Tipo de cuenta" }}</div>
                  <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 200px;">{{ accountDetailData.sAccountType }}</div>
                </div>
                <div class="d-flex mb-2" style="justify-content: space-between" v-if="accountDetailData.sRoutingNumber">
                  <div style="font-family: 'montserrat-bold';">{{ "Routing Number" }}</div>
                  <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 200px;">{{ accountDetailData.sRoutingNumber }}</div>
                </div>
                <div class="d-flex mb-2" style="justify-content: space-between" v-if="accountDetailData.swiftCode">
                  <div style="font-family: 'montserrat-bold';">{{ "Swift Code" }}</div>
                  <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 200px;">{{ accountDetailData.swiftCode }}</div>
                </div>
                <div class="d-flex mb-2" style="justify-content: space-between" v-if="accountDetailData.sEmail">
                  <div style="font-family: 'montserrat-bold';">{{ "Email" }}</div>
                  <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 200px;">{{ accountDetailData.sEmail }}</div>
                </div>
              </v-card-text>
            </v-card>
            <div v-else class="text-center py-4">
              <span>No se encontró información de la cuenta</span>
            </div>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogWithdrawal" v-model="dialogWithdrawal" persistent max-width="680" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header v-if="e1 < 3" color="Black" class="mt-5 mr-15 ml-15" elevation="0" 
            style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
          >
            <v-stepper-step :complete="e1 > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0" style="">
              <v-container class="mt-1">
                <v-card elevation="0" style="max-width: 680px;">
                  <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                    <span style="font-family: 'montserrat-bold'; font-size: 28px; color: black;">
                      {{ "Crear Retiro" }}
                    </span>
                  </v-card-title>
                  <v-card-text class="py-6 px-4 pt-0">
                    <!-- Wallet Origen -->
                    <div>
                      <v-row class="">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Selecciona la wallet origen" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col>
                          <v-card class="d-flex" outlined @click="selectedCurrency = 'USD', exchangeRateToday = '', exchangeRateTodayReference = '',  amounts = { USD: 0, MXN: 0 }, selectedTypeOfPayment = null, comment = ''" elevation="2"
                            style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 100%;"
                          >
                            <div class="pa-2" style="display: flex; align-items: flex-start; justify-content: space-between;">
                              <div>
                                <div style="margin-right: 30px">
                                  <v-img src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                                  <div style="font-family: 'montserrat-bold';">{{ "Wallet USD" }}</div>
                                </div>
                              </div>
                              <v-icon v-if="selectedCurrency === 'USD'" color="black">mdi-check-circle</v-icon>
                              <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                            </div>
                            <div class="pa-2">
                              <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                                ${{ formatMoney(enterprise.balance?.balanceUsd?.balance ? enterprise.balance?.balanceUsd?.balance : 0) }} USD
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card class="d-flex" outlined @click="selectedCurrency = 'MXN', exchangeRateToday = '', exchangeRateTodayReference = '', amounts = { USD: 0, MXN: 0 }, selectedTypeOfPayment = null, comment = ''" elevation="2"
                            style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between;"
                          >
                            <div class="pa-2" style="display: flex; align-items: flex-start; justify-content: space-between;">
                              <div>
                                <div style="margin-right: 30px">
                                  <v-img src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                                  <div style="font-family: 'montserrat-bold';">{{ "Wallet MXN" }}</div>
                                </div>
                              </div>
                              <v-icon v-if="selectedCurrency === 'MXN'" color="black">mdi-check-circle</v-icon>
                              <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                            </div>
                            <div class="pa-2">
                              <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                                ${{ formatMoney(enterprise.balance?.balanceMxn?.balance ? enterprise.balance?.balanceMxn?.balance : 0) }} MXN
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                    <!-- TC -->
                    <div v-if="selectedCurrency && supplier ? (selectedCurrency != (supplier?.sAccountCurrency)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa el UUID del TC o genera uno" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0" style="display: flex; align-items: center;">
                        <v-col>
                          <v-text-field
                            v-model="exchangeRateTodayReference"
                            filled
                            @change="calculatorAmount(amounts[selectedCurrency], false, selectedCurrency, supplier?.sAccountCurrency)"
                            :disabled="selectedCurrency === null"
                            :loading="isLoadingRate"
                            rounded
                            style="min-width: 100px;"
                            label="Ingresa el UUID"
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-btn
                            color="black"
                            class="py-5 white--text"
                            elevation="2"
                            rounded
                            :loading="isLoadingRate"
                            block
                            @click="getRate(selectedCurrency, supplier?.sAccountCurrency)"
                          >
                            <span style="font-family: 'montserrat-semibold';">{{ "Generar UUID" }}</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                      <v-col>
                        <div class="info-block" style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                          <p class="label">Tipo de cambio:</p>
                          <p class="value" v-if="exchangeRateTodayReference">{{ "$" + exchangeRateToday + " MXN" }}</p>
                        </div>
                      </v-col>
                    </v-row>
                    </div>

                    <!-- Montos -->
                    <div v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa el monto a pagar" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col>
                          <v-text-field
                            outlined
                            :label="`De ${currencyMap[selectedCurrency]?.name}`"
                            type="number"
                            dense
                            :loading="isLoadingRate"
                            :disabled="selectedCurrency != (supplier?.sAccountCurrency) ? isLoadingRate : false"
                            hide-details
                            v-model="amounts[selectedCurrency]"
                            @change="selectedCurrency != (supplier?.sAccountCurrency) ? calculatorAmount(amounts[selectedCurrency], false, selectedCurrency, supplier?.sAccountCurrency) : null"
                            prefix="$"
                          >
                            <template v-slot:append>
                              <div class="d-flex align-center">
                                <img
                                  :src="currencyMap[selectedCurrency]?.flag"
                                  width="24"
                                  height="24"
                                  alt=""
                                  class="rounded"
                                />
                                <h4 class="ml-2 font-weight-bold">{{ selectedCurrency }}</h4>
                              </div>
                            </template>
                          </v-text-field>
                          <v-text-field
                            outlined
                            :label="`A ${currencyMap[supplier?.sAccountCurrency]?.name}`"
                            type="number"
                            dense
                            hide-details
                            :loading="isLoadingRate"
                            v-if="selectedCurrency != (supplier?.sAccountCurrency)"
                            :disabled="selectedCurrency != (supplier?.sAccountCurrency) ? isLoadingRate : false"
                            v-model="amounts[supplier?.sAccountCurrency]"
                            @change="(calculatorAmount(amounts[supplier?.sAccountCurrency], true, selectedCurrency, supplier?.sAccountCurrency))"
                            prefix="$"
                            class="mt-4"
                          >
                            <template v-slot:append>
                              <div class="d-flex align-center">
                                <img
                                  :src="currencyMap[supplier?.sAccountCurrency]?.flag"
                                  width="24"
                                  height="24"
                                  alt=""
                                  class="rounded"
                                />
                                <h4 class="ml-2 font-weight-bold">{{ supplier?.sAccountCurrency }}</h4>
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- Detalle de montos -->
                    <div class="py-6" v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-row class="align-center">
                        <v-col>
                          <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                            {{ "Total origin" }}
                          </div>
                        </v-col>
                        <v-col class="d-flex justify-end">
                          <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold';">
                            ${{ amounts[selectedCurrency] ? formatMoney(amounts[selectedCurrency]) : 0 }} {{ selectedCurrency }}
                          </h2>
                        </v-col>
                      </v-row>
                      <v-row class="align-center mt-0">
                        <v-col>
                          <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                            {{ selectedCurrency == (supplier?.sAccountCurrency) ? "Cantidad a enviar" : "Total destination" }}
                          </div>
                        </v-col>
                        <v-col class="d-flex justify-end">
                          <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold';">
                            ${{ amounts[supplier?.sAccountCurrency] ? formatMoney(amounts[supplier?.sAccountCurrency]) : 0 }} {{ supplier?.sAccountCurrency }}
                          </h2>
                        </v-col>
                      </v-row>
                    </div>

                    <div class="info-block" v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-textarea
                        class="pa-4"
                        rows="2"
                        :label="'Concepto de retiro'"
                        v-model="comment"
                        no-resize
                        hide-details
                      ></v-textarea>
                    </div>

                    <!-- Spot o Window Spot -->
                    <div v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : false)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <v-card class="d-flex pa-2 mb-3" @click="selectedTypeOfPayment = 'Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; height: 100%;">
                            <div>
                              <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Retiro instantaneo" }}</div>
                              <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                                {{ "Al utilizar retiro instantaneo se descontara del balance origen y se enviara a la wallet destino." }}
                              </div>
                            </div>
                            <v-icon v-if="selectedTypeOfPayment === 'Spot'" color="black">mdi-check-circle</v-icon>
                            <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card class="d-flex pa-2" @click="selectedTypeOfPayment = 'Window Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; height: 100%;">
                            <div>
                              <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Retiro diferido" }}</div>
                              <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                                {{ "Al utilizar retiro diferido se creara un window spot y le permitira depositar el monto origen y una vez se refleje se enviara a tu destinatario." }}
                              </div>
                            </div>
                            <v-icon v-if="selectedTypeOfPayment === 'Window Spot'" color="black">mdi-check-circle</v-icon>
                            <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      @click="selectedCurrency = null, dialogWithdrawal = false, amounts = { USD: 0, MXN: 0 }, exchangeRateToday = '', exchangeRateTodayReference = '', selectedTypeOfPayment = null, comment = '', supplier = null"
                    >
                      {{ "Cancel" }}
                    </v-btn>
                    <v-btn
                      color="black"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="selectedCurrency === null || amounts[selectedCurrency] == 0 || amounts[supplier?.sAccountCurrency] == 0 || (selectedCurrency != (supplier?.sAccountCurrency) ? selectedTypeOfPayment == null : false) || comment == '' "
                      @click="e1 = 2"
                    >
                      {{ "Next" }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" class="pt-0">
              <v-card class="pa-6 mx-auto">
                <v-card-text class="pb-0 px-0" >
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="supplier">
                        <p class="label">Número de cuenta:</p>
                        <p class="value" >{{ "*" + (supplier ? (supplier?.sAccountNumber ? (supplier?.sAccountNumber).slice(-4) : (supplier?.accountNumber).slice(-4)) : '') }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else style="align-items: center;">
                          <v-chip v-if="selectedTypeOfPayment == 'Spot'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Spot" }}
                          </v-chip>
                          <v-chip v-else-if="selectedTypeOfPayment == 'Window Spot'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de retiro:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[supplier?.sAccountCurrency]) + " " + (supplier?.sAccountCurrency) }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Withdrawal concept:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="e1 = 1"
                  >
                    {{ "Back" }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    @click="sendPayment(), e1 = 3"
                  >
                    {{ "Confirm" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3" class="pt-0">
              <v-btn icon @click="dialogWithdrawal = false, selectedCurrency = null, selectedTypeOfPayment = '', comment = '', amounts = { MXN: null, USD: null }, paymentError = false, loadingPayment = false, getClient(), e1 = 1" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-card class="pa-6 mx-auto">
                <div v-if="loadingPayment" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando retiro...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ selectedTypeOfPayment === 'Window Spot' ? "Retiro programado correctamente!" : "Retiro procesado correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al procesar el retiro!
                  </v-card-title>
                </div>
                <v-card-text class="pb-0 px-0">
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="supplier">
                        <p class="label">Número de cuenta:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "*" + (supplier ? ((supplier?.accountNumber ? (supplier?.accountNumber).slice(-4) : (supplier?.sAccountNumber).slice(-4))) : '') }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else style="align-items: center;">
                          <v-chip v-if="selectedTypeOfPayment == 'Spot'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Forex" }}
                          </v-chip>
                          <v-chip v-else-if="selectedTypeOfPayment == 'Window Spot'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de retiro:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[supplier?.sAccountCurrency]) + " " + (supplier?.sAccountCurrency) }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Withdrawal concept:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogSendPay" v-model="dialogSendPay" persistent max-width="680" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header v-if="e1 < 3" color="Black" class="mt-5 mr-15 ml-15" elevation="0" 
            style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
          >
            <v-stepper-step :complete="e1 > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0" style="">
              <v-container class="mt-1">
                <v-card elevation="0" style="max-width: 680px;">
                  <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                    <span style="font-family: 'montserrat-bold'; font-size: 28px; color: black;">
                      {{ "Crear Pago" }}
                    </span>
                  </v-card-title>
                  <v-card-text class="py-6 px-4 pt-0">
                    <!-- Wallet Origen -->
                    <div>
                      <v-row class="">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Selecciona la wallet origen" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col>
                          <v-card class="d-flex" outlined @click="selectedCurrency = 'USD', exchangeRateToday = '', exchangeRateTodayReference = '',  amounts = { USD: 0, MXN: 0 }, supplier = null, selected = null, selectedTypeOfPayment = null, comment = ''" elevation="2"
                            style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 100%;"
                          >
                            <div class="pa-2" style="display: flex; align-items: flex-start; justify-content: space-between;">
                              <div>
                                <div style="margin-right: 30px">
                                  <v-img src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                                  <div style="font-family: 'montserrat-bold';">{{ "Wallet USD" }}</div>
                                </div>
                              </div>
                              <v-icon v-if="selectedCurrency === 'USD'" color="black">mdi-check-circle</v-icon>
                              <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                            </div>
                            <div class="pa-2">
                              <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                                ${{ formatMoney(enterprise.balance?.balanceUsd?.balance ? enterprise.balance?.balanceUsd?.balance : 0) }} USD
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card class="d-flex" outlined @click="selectedCurrency = 'MXN', exchangeRateToday = '', exchangeRateTodayReference = '', amounts = { USD: 0, MXN: 0 }, supplier = null, selected = null, selectedTypeOfPayment = null, comment = ''" elevation="2"
                            style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between;"
                          >
                            <div class="pa-2" style="display: flex; align-items: flex-start; justify-content: space-between;">
                              <div>
                                <div style="margin-right: 30px">
                                  <v-img src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                                  <div style="font-family: 'montserrat-bold';">{{ "Wallet MXN" }}</div>
                                </div>
                              </div>
                              <v-icon v-if="selectedCurrency === 'MXN'" color="black">mdi-check-circle</v-icon>
                              <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                            </div>
                            <div class="pa-2">
                              <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                                ${{ formatMoney(enterprise.balance?.balanceMxn?.balance ? enterprise.balance?.balanceMxn?.balance : 0) }} MXN
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- Supplier -->
                    <div v-if="selectedCurrency">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Selecciona el destinatario" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col>
                          <v-autocomplete
                            :items="suppliers"
                            filled
                            rounded
                            label="Contactos"
                            item-text="sNameAC"
                            return-object
                            v-model="selected"
                            @change="supplier = selected"
                            hide-details
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- TC -->
                    <div v-if="selectedCurrency && supplier ? (selectedCurrency != (supplier?.sAccountCurrency)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa el UUID del TC o genera uno" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0" style="display: flex; align-items: center;">
                        <v-col>
                          <v-text-field
                            v-model="exchangeRateTodayReference"
                            filled
                            @change="calculatorAmount(amounts[selectedCurrency], false, selectedCurrency, supplier?.sAccountCurrency)"
                            :disabled="selectedCurrency === null"
                            :loading="isLoadingRate"
                            rounded
                            style="min-width: 100px;"
                            label="Ingresa el UUID"
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-btn
                            color="black"
                            class="py-5 white--text"
                            elevation="2"
                            rounded
                            :loading="isLoadingRate"
                            block
                            @click="getRate(selectedCurrency, supplier?.sAccountCurrency)"
                          >
                            <span style="font-family: 'montserrat-semibold';">{{ "Generar UUID" }}</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                      <v-col>
                        <div class="info-block" style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                          <p class="label">Tipo de cambio:</p>
                          <p class="value" v-if="exchangeRateTodayReference">{{ "$" + exchangeRateToday + " MXN" }}</p>
                        </div>
                      </v-col>
                    </v-row>
                    </div>

                    <!-- Montos -->
                    <div v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa el monto a pagar" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col>
                          <v-text-field
                            outlined
                            :label="`De ${currencyMap[selectedCurrency]?.name}`"
                            type="number"
                            dense
                            :loading="isLoadingRate"
                            :disabled="selectedCurrency != (supplier?.sAccountCurrency) ? isLoadingRate : false"
                            hide-details
                            v-model="amounts[selectedCurrency]"
                            @change="selectedCurrency != (supplier?.sAccountCurrency) ? calculatorAmount(amounts[selectedCurrency], false, selectedCurrency, supplier?.sAccountCurrency) : null"
                            prefix="$"
                          >
                            <template v-slot:append>
                              <div class="d-flex align-center">
                                <img
                                  :src="currencyMap[selectedCurrency]?.flag"
                                  width="24"
                                  height="24"
                                  alt=""
                                  class="rounded"
                                />
                                <h4 class="ml-2 font-weight-bold">{{ selectedCurrency }}</h4>
                              </div>
                            </template>
                          </v-text-field>
                          <v-text-field
                            outlined
                            :label="`A ${currencyMap[supplier?.sAccountCurrency]?.name}`"
                            type="number"
                            dense
                            hide-details
                            :loading="isLoadingRate"
                            v-if="selectedCurrency != (supplier?.sAccountCurrency)"
                            :disabled="selectedCurrency != (supplier?.sAccountCurrency) ? isLoadingRate : false"
                            v-model="amounts[supplier?.sAccountCurrency]"
                            @change="(calculatorAmount(amounts[supplier?.sAccountCurrency], true, selectedCurrency, supplier?.sAccountCurrency))"
                            prefix="$"
                            class="mt-4"
                          >
                            <template v-slot:append>
                              <div class="d-flex align-center">
                                <img
                                  :src="currencyMap[supplier?.sAccountCurrency]?.flag"
                                  width="24"
                                  height="24"
                                  alt=""
                                  class="rounded"
                                />
                                <h4 class="ml-2 font-weight-bold">{{ supplier?.sAccountCurrency }}</h4>
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- Detalle de montos -->
                    <div class="py-6" v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-row class="align-center">
                        <v-col>
                          <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                            {{ "Total origin" }}
                          </div>
                        </v-col>
                        <v-col class="d-flex justify-end">
                          <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold';">
                            ${{ amounts[selectedCurrency] ? formatMoney(amounts[selectedCurrency]) : 0 }} {{ selectedCurrency }}
                          </h2>
                        </v-col>
                      </v-row>
                      <v-row class="align-center mt-0">
                        <v-col>
                          <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                            {{ selectedCurrency == (supplier?.sAccountCurrency) ? "Cantidad a enviar" : "Total destination" }}
                          </div>
                        </v-col>
                        <v-col class="d-flex justify-end">
                          <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold';">
                            ${{ amounts[supplier?.sAccountCurrency] ? formatMoney(amounts[supplier?.sAccountCurrency]) : 0 }} {{ supplier?.sAccountCurrency }}
                          </h2>
                        </v-col>
                      </v-row>
                    </div>

                    <div class="info-block" v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-textarea
                        class="pa-4"
                        rows="2"
                        :label="'Concepto de pago'"
                        v-model="comment"
                        no-resize
                        hide-details
                      ></v-textarea>
                    </div>

                    <!-- Spot o Window Spot -->
                    <div v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : false)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <v-card class="d-flex pa-2 mb-3" @click="selectedTypeOfPayment = 'Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; height: 100%;">
                            <div>
                              <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Pago instantaneo" }}</div>
                              <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                                {{ "Al utilizar pago instantaneo se descontara del balance origen y se enviara a la wallet destino." }}
                              </div>
                            </div>
                            <v-icon v-if="selectedTypeOfPayment === 'Spot'" color="black">mdi-check-circle</v-icon>
                            <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card class="d-flex pa-2" @click="selectedTypeOfPayment = 'Window Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; height: 100%;">
                            <div>
                              <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Pago diferido" }}</div>
                              <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                                {{ "Al utilizar pago diferido se creara un window spot y le permitira depositar el monto origen y una vez se refleje se enviara a tu destinatario." }}
                              </div>
                            </div>
                            <v-icon v-if="selectedTypeOfPayment === 'Window Spot'" color="black">mdi-check-circle</v-icon>
                            <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      @click="selectedCurrency = null, dialogSendPay = false, selected = null, supplier = null, amounts = { USD: 0, MXN: 0 }, exchangeRateToday = '', exchangeRateTodayReference = '', selectedTypeOfPayment = null, comment = ''"
                    >
                      {{ "Cancel" }}
                    </v-btn>
                    <v-btn
                      color="black"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="selectedCurrency === null || amounts[selectedCurrency] == 0 || amounts[supplier?.sAccountCurrency] == 0 || (selectedCurrency != (supplier?.sAccountCurrency) ? selectedTypeOfPayment == null : false) || comment == '' "
                      @click="e1 = 2"
                    >
                      {{ "Next" }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" class="pt-0">
              <v-card class="pa-6 mx-auto">
                <v-card-text class="pb-0 px-0" >
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="supplier">
                        <p class="label">Número de cuenta:</p>
                        <p class="value" >{{ "*" + (supplier ? (supplier?.sAccountNumber ? (supplier?.sAccountNumber).slice(-4) : (supplier?.accountNumber).slice(-4)) : '') }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else style="align-items: center;">
                          <v-chip v-if="selectedTypeOfPayment == 'Spot'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Spot" }}
                          </v-chip>
                          <v-chip v-else-if="selectedTypeOfPayment == 'Window Spot'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de pago:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[supplier?.sAccountCurrency]) + " " + (supplier?.sAccountCurrency) }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Payment concept:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="e1 = 1"
                  >
                    {{ "Back" }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    @click="sendPayment(), e1 = 3"
                  >
                    {{ "Confirm" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3" class="pt-0">
              <v-btn icon @click="dialogSendPay = false, selectedCurrency = null, selected = null, selectedTypeOfPayment = '', comment = '', amounts = { MXN: null, USD: null }, paymentError = false, loadingPayment = false, getClient(), e1 = 1" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-card class="pa-6 mx-auto">
                <div v-if="loadingPayment" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando pago...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ selectedTypeOfPayment === 'Window Spot' ? "Pago programado correctamente!" : "Pago procesado correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al procesar el pago!
                  </v-card-title>
                </div>
                <v-card-text class="pb-0 px-0">
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="supplier">
                        <p class="label">Número de cuenta:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "*" + (supplier ? ((supplier?.accountNumber ? (supplier?.accountNumber).slice(-4) : (supplier?.sAccountNumber).slice(-4))) : '') }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else style="align-items: center;">
                          <v-chip v-if="selectedTypeOfPayment == 'Spot'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Forex" }}
                          </v-chip>
                          <v-chip v-else-if="selectedTypeOfPayment == 'Window Spot'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de pago:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[supplier?.sAccountCurrency]) + " " + (supplier?.sAccountCurrency) }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Payment concept:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogSendPayMassive" v-model="dialogSendPayMassive" persistent max-width="900" class="pa-8">
      <v-card>
        <v-stepper v-model="massPaymentStep" alt-labels elevation="0">
          <!-- HEADER -->
          <v-stepper-header v-if="massPaymentStep < 3" color="Black" class="mt-5 mr-15 ml-15" elevation="0" 
            style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
          >
            <v-stepper-step step="1" :complete="massPaymentStep > 1" color="black">
              Pagos
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="massPaymentStep > 2" color="black">
              Resumen
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" color="black">
              Resultado
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- STEP 1: WALLET SELECTION AND PAYMENT ROWS -->
            <v-stepper-content step="1">
              <v-card-text class="py-6 px-4">
                <v-row>
                  <v-col cols="12" class="d-flex justify-space-between align-center">
                    <h2 style="font-family: 'montserrat-bold'; font-size: 28px; color: black;">{{ "Crear Pagos Masivos" }}</h2>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12">
                    <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Selecciona la wallet origen" }}</h4>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-card
                      class="d-flex"
                      outlined
                      @click="selectMassPaymentCurrencyUSD()"
                      elevation="2"
                      style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; cursor: pointer;"
                    >
                      <div class="pa-2" style="display: flex; align-items: center; justify-content: space-between;">
                        <div>
                          <v-img src="../../assets/images/Flags_usa.svg" alt="usd-flag" width="50" height="30"/>
                          <div style="font-family: 'montserrat-bold';">{{ "Wallet USD" }}</div>
                        </div>
                        <v-icon v-if="massPaymentOriginCurrency === 'USD'" color="black">mdi-check-circle</v-icon>
                        <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                      </div>
                      <div class="pa-2">
                        <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                          ${{ formatMoney(enterprise.balance?.balanceUsd?.balance ? enterprise.balance?.balanceUsd?.balance : 0) }} USD
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card
                      class="d-flex"
                      outlined
                      @click="selectMassPaymentCurrencyMXN()"
                      elevation="2"
                      style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; cursor: pointer;"
                    >
                      <div class="pa-2" style="display: flex; align-items: center; justify-content: space-between;">
                        <div>
                          <v-img src="../../assets/images/Flags_mex.svg" alt="mxn-flag" width="50" height="30"/>
                          <div style="font-family: 'montserrat-bold';">{{ "Wallet MXN" }}</div>
                        </div>
                        <v-icon v-if="massPaymentOriginCurrency === 'MXN'" color="black">mdi-check-circle</v-icon>
                        <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                      </div>
                      <div class="pa-2">
                        <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                          ${{ formatMoney(enterprise.balance?.balanceMxn?.balance ? enterprise.balance?.balanceMxn?.balance : 0) }} MXN
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <div v-if="massPaymentOriginCurrency">
                  <v-row class="mt-4" v-for="(row, index) in massPaymentsRows" :key="row.id" style="border: 2px solid #dddddd; border-radius: 15px; padding: 20px; margin: 0px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);" >
                    <v-row align="center">
                      <v-col cols="12" style="display: flex; align-items: center;">
                        <v-autocomplete
                          :items="suppliers"
                          filled
                          rounded
                          dense
                          label="Contactos"
                          item-text="sNameAC"
                          return-object
                          v-model="row.supplier"
                          @change="onMassPaymentSupplierChange(row)"
                          hide-details
                        ></v-autocomplete>
                        <v-btn class="ml-2" icon color="red" @click="removeMassPaymentRow(index)" :disabled="massPaymentsRows.length === 1">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <div v-if="row.supplier && row.supplier.sAccountCurrency !== massPaymentOriginCurrency" style="display: flex; align-items: center; margin-left: 20px;">
                          <v-text-field
                            v-model="row.exchangeRateReference"
                            filled
                            style="min-width: 300px;"
                            dense
                            rounded
                            :disabled="row.loadingRate"
                            label="UUID de tipo de cambio"
                            hide-details
                          ></v-text-field>
                          <v-btn
                            color="black"
                            class="py-5 ml-2 white--text"
                            elevation="2"
                            rounded
                            :loading="row.loadingRate"
                            @click="getRateForMassRow(row)"
                          >
                            <span style="font-family: 'montserrat-semibold';">{{ "Generar UUID" }}</span>
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row v-if="row.supplier && row.supplier.sAccountCurrency !== massPaymentOriginCurrency">
                      <v-col cols="12">
                        <div class="info-block" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 0px;">
                          <p class="label">Tipo de cambio:</p>
                          <p class="value" v-if="row.exchangeRateToday">{{ "$" + row.exchangeRateToday + " MXN" }}</p>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="mt-4">
                      <v-col cols="12" md="4">
                        <v-text-field
                          outlined
                          :label="`De ${currencyMap[massPaymentOriginCurrency]?.name}`"
                          type="number"
                          dense
                          rounded
                          :loading="row.loadingRate"
                          :disabled="row.supplier?.sAccountCurrency !== massPaymentOriginCurrency && !row.exchangeRateReference"
                          hide-details
                          v-model="row.originAmount"
                          @change="row.supplier?.sAccountCurrency === massPaymentOriginCurrency ? row.destAmount = parseFloat(row.originAmount || 0).toFixed(2) : calculatorAmountForMassRow(row, row.originAmount, false)"
                          prefix="$"
                        >
                          <template v-slot:append>
                            <div class="d-flex align-center">
                              <img
                                :src="currencyMap[massPaymentOriginCurrency]?.flag"
                                width="24"
                                height="24"
                                alt=""
                                class="rounded"
                              />
                              <h4 class="ml-2 font-weight-bold">{{ massPaymentOriginCurrency }}</h4>
                            </div>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          outlined
                          :label="`A ${row.supplier?.sAccountCurrency ? currencyMap[row.supplier.sAccountCurrency]?.name : ''}`"
                          type="number"
                          dense
                          rounded
                          hide-details
                          :disabled="row.supplier?.sAccountCurrency !== massPaymentOriginCurrency && !row.exchangeRateReference"
                          v-model="row.destAmount"
                          @change="row.supplier?.sAccountCurrency === massPaymentOriginCurrency ? row.originAmount = parseFloat(row.destAmount || 0).toFixed(2) : calculatorAmountForMassRow(row, row.destAmount, true)"
                          prefix="$"
                        >
                          <template v-slot:append>
                            <div class="d-flex align-center">
                              <img
                                :src="row.supplier?.sAccountCurrency ? currencyMap[row.supplier.sAccountCurrency]?.flag : ''"
                                width="24"
                                height="24"
                                alt=""
                                class="rounded"
                              />
                              <h4 class="ml-2 font-weight-bold">{{ row.supplier?.sAccountCurrency }}</h4>
                            </div>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          rounded
                          outlined
                          dense
                          :label="'Concepto de pago'"
                          v-model="row.comment"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-row>

                  <v-row>
                    <v-col cols="12" class="d-flex justify-center">
                      <v-btn
                        color="black"
                        outlined
                        style="border-radius: 36px; text-transform: none; font-family: 'montserrat-semibold'; border: 2px solid black;"
                        @click="addMassPaymentRow()"
                      >
                        {{ "Agregar otro pago" }}
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row class="mt-6">
                    <v-col cols="12" md="6">
                      <div class="info-block">
                        <div class="label">Costo total:</div>
                        <div class="value">${{ formatMoney(massPaymentTotalOrigin) }} {{ massPaymentOriginCurrency }}</div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>

              <v-card-actions class="pa-6" style="justify-content: space-between;">
                <v-btn
                  elevation="4"
                  class="mr-2 px-10"
                  style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  @click="resetMassPaymentDialog()"
                >
                  {{ "Cancel" }}
                </v-btn>
                <v-btn
                  color="black"
                  elevation="4"
                  class="white--text px-10"
                  style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                  :disabled="!canSubmitMassPayment"
                  @click="massPaymentStep = 2"
                >
                  {{ "Siguiente" }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>

            <!-- STEP 2: SUMMARY / REVIEW -->
            <v-stepper-content step="2">
              <v-card-text class="py-6 px-4">
                <v-row>
                  <v-col cols="12">
                    <h2 style="font-family: 'montserrat-bold'; font-size: 28px; color: black;">{{ "Resumen de Pagos" }}</h2>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" md="6">
                    <div class="info-block">
                      <div class="label">Balance:</div>
                      <div class="value">{{ "$" + formatMoney(massPaymentOriginCurrency === 'USD' ? enterprise.balance?.balanceUsd?.balance : enterprise.balance?.balanceMxn?.balance) + " " + massPaymentOriginCurrency }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="info-block">
                      <div class="label">Cantidad de pagos:</div>
                      <div class="value">{{ massPaymentsRows.length }}</div>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="mt-4">
                  <v-col cols="12">
                    <h4 style="font-family: 'montserrat-bold'; margin-bottom: 16px;">{{ "Detalle de pagos" }}</h4>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #f5f5f5;">
                            <th style="font-family: 'montserrat-bold'; color: black;">Beneficiario</th>
                            <th style="font-family: 'montserrat-bold'; color: black;">Monto Origen</th>
                            <th style="font-family: 'montserrat-bold'; color: black;">Monto Destino</th>
                            <th style="font-family: 'montserrat-bold'; color: black;">Concepto</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in massPaymentsRows" :key="row.id">
                            <td>{{ row.supplier?.sNameAC }}</td>
                            <td>${{ formatMoney(row.originAmount) }} {{ massPaymentOriginCurrency }}</td>
                            <td>${{ formatMoney(row.destAmount) }} {{ row.supplier?.sAccountCurrency }}</td>
                            <td>{{ row.comment || '-' }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" md="6">
                    <div class="info-block">
                      <div class="label">Total a pagar:</div>
                      <div class="value" style="color: #12A150;">
                        ${{ formatMoney(massPaymentTotalOrigin) }} {{ massPaymentOriginCurrency }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions class="pa-6" style="justify-content: space-between;">
                <v-btn
                  elevation="4"
                  class="mr-2 px-10"
                  style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  @click="massPaymentStep = 1"
                >
                  {{ "Anterior" }}
                </v-btn>
                <v-btn
                  color="black"
                  elevation="4"
                  class="white--text px-10"
                  style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                  @click="proceedWithMassPayment()"
                >
                  {{ "Confirmar y Pagar" }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>

            <!-- STEP 3: RESULT -->
            <v-stepper-content step="3">
              <v-card-text class="py-6 px-4">
                <v-row style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
                  <v-col cols="12" class="text-center">
                    <div v-if="massPaymentLoading" class="text-center">
                      <v-progress-circular indeterminate color="black" size="64"></v-progress-circular>
                      <h3 class="mt-6" style="font-family: 'montserrat-bold'; color: black;">{{ "Procesando tu pago masivo..." }}</h3>
                    </div>

                    <div v-else-if="massPaymentSuccess" class="text-center">
                      <h3 style="font-family: 'montserrat-bold'; font-size: 24px;" :style="{ color: massPaymentFailedCount > 0 ? '#F57C00' : '#12A150' }">
                        {{ massPaymentFailedCount > 0 ? 'Pago masivo procesado con observaciones' : '¡Pago masivo realizado exitosamente!' }}
                      </h3>
                    </div>

                    <div v-else class="text-center">
                      <v-icon size="80" color="#D32F2F">mdi-alert-circle</v-icon>
                      <h3 style="font-family: 'montserrat-bold'; color: #D32F2F; font-size: 24px;">{{ "Error al procesar el pago" }}</h3>
                      <p class="mt-4" style="font-family: 'montserrat-regular'; color: #666; font-size: 16px;">
                        {{ massPaymentResultMessage }}
                      </p>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="!massPaymentLoading && massPaymentResults.length > 0" class="mt-6">
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #f5f5f5;">
                            <th style="font-family: 'montserrat-bold'; color: black;">Proveedor</th>
                            <th style="font-family: 'montserrat-bold'; color: black;">Monto Origen</th>
                            <th style="font-family: 'montserrat-bold'; color: black;">Monto Destino</th>
                            <th style="font-family: 'montserrat-bold'; color: black;">Estatus</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in massPaymentResults" :key="row.id">
                            <td>{{ row.beneficiaryName }}</td>
                            <td>${{ formatMoney(row.originAmount) }} {{ row.originCurrency }}</td>
                            <td>${{ formatMoney(row.destAmount) }} {{ row.destCurrency }}</td>
                            <td>
                              <v-chip
                                :color="row.success === true ? 'success' : 'error'"
                                text-color="white"
                                small
                              >
                                {{ row.success === true ? 'Exitoso' : 'Fallido' }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions class="pa-6" style="justify-content: space-between;" v-if="!massPaymentLoading">
                <v-btn
                  elevation="4"
                  class="px-10"
                  style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  @click="resetMassPaymentDialog(), getClient()"
                >
                  {{ "Cerrar" }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogSendPayWithTransaction" v-model="dialogSendPayWithTransaction" max-width="680" style="margin: auto;" persistent class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header v-if="e1 < 3" color="Black" class="mt-5 mr-15 ml-15" elevation="0" 
            style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
          >
            <v-stepper-step :complete="e1 > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0" style="">
              <v-container class="mt-1">
                <v-card elevation="0" style="max-width: 680px;">
                  <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                    <span style="font-family: 'montserrat-bold'; font-size: 28px; color: black;">
                      {{ "Crear Pago" }}
                    </span>
                  </v-card-title>
                  <v-card-text class="py-6 px-4 pt-0">
                    <!-- Wallet Origen -->
                    <div>
                      <v-row class="">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Selecciona la wallet origen" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col v-if="selectedCurrency == 'USD'">
                          <v-card  class="d-flex" outlined @click="selectedCurrency = 'USD', exchangeRateToday = '', exchangeRateTodayReference = '',  amounts = { USD: 0, MXN: 0 }, supplier = null, selected = null, selectedTypeOfPayment = null, comment = ''" elevation="2"
                            style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 100%;"
                          >
                            <div class="pa-2" style="display: flex; align-items: flex-start; justify-content: space-between;">
                              <div>
                                <div style="margin-right: 30px">
                                  <v-img src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                                  <div style="font-family: 'montserrat-bold';">{{ "Wallet USD" }}</div>
                                </div>
                              </div>
                              <v-icon v-if="selectedCurrency === 'USD'" color="black">mdi-check-circle</v-icon>
                              <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                            </div>
                            <div class="pa-2">
                              <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                                ${{ formatMoney(avaibleAmount) }} USD
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card class="d-flex" outlined @click="selectedCurrency = 'MXN', exchangeRateToday = '', exchangeRateTodayReference = '', amounts = { USD: 0, MXN: 0 }, supplier = null, selected = null, selectedTypeOfPayment = null, comment = ''" elevation="2"
                            style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between;"
                          >
                            <div class="pa-2" style="display: flex; align-items: flex-start; justify-content: space-between;">
                              <div>
                                <div style="margin-right: 30px">
                                  <v-img src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                                  <div style="font-family: 'montserrat-bold';">{{ "Wallet MXN" }}</div>
                                </div>
                              </div>
                              <v-icon v-if="selectedCurrency === 'MXN'" color="black">mdi-check-circle</v-icon>
                              <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                            </div>
                            <div class="pa-2">
                              <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                                ${{ formatMoney(avaibleAmount) }} MXN
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- Supplier -->
                    <div v-if="selectedCurrency">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Selecciona el destinatario" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col>
                          <v-autocomplete
                            :items="suppliers"
                            filled
                            rounded
                            label="Contactos"
                            item-text="sNameAC"
                            return-object
                            v-model="selected"
                            @change="supplier = selected"
                            hide-details
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- TC -->
                    <div v-if="selectedCurrency && supplier ? (selectedCurrency != (supplier?.sAccountCurrency)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa el UUID del TC o genera uno" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0" style="display: flex; align-items: center;">
                        <v-col>
                          <v-text-field
                            v-model="exchangeRateTodayReference"
                            filled
                            @change="calculatorAmount(amounts[selectedCurrency], false, selectedCurrency, supplier?.sAccountCurrency)"
                            :disabled="selectedCurrency === null"
                            :loading="isLoadingRate"
                            rounded
                            style="min-width: 100px;"
                            label="Ingresa el UUID"
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-btn
                            color="black"
                            class="py-5 white--text"
                            elevation="2"
                            rounded
                            :loading="isLoadingRate"
                            block
                            @click="getRate(selectedCurrency, supplier?.sAccountCurrency)"
                          >
                            <span style="font-family: 'montserrat-semibold';">{{ "Generar UUID" }}</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                      <v-col>
                        <div class="info-block" style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                          <p class="label">Tipo de cambio:</p>
                          <p class="value" v-if="exchangeRateTodayReference">{{ "$" + exchangeRateToday + " MXN" }}</p>
                        </div>
                      </v-col>
                    </v-row>
                    </div>

                    <!-- Montos -->
                    <div v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa el monto a pagar" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col>
                          <v-text-field
                            outlined
                            :label="`De ${currencyMap[selectedCurrency]?.name}`"
                            type="number"
                            dense
                            :loading="isLoadingRate"
                            :disabled="selectedCurrency != (supplier?.sAccountCurrency) ? isLoadingRate : false"
                            hide-details
                            v-model="amounts[selectedCurrency]"
                            @change="selectedCurrency != (supplier?.sAccountCurrency) ? calculatorAmount(amounts[selectedCurrency], false, selectedCurrency, supplier?.sAccountCurrency) : null"
                            prefix="$"
                          >
                            <template v-slot:append>
                              <div class="d-flex align-center">
                                <img
                                  :src="currencyMap[selectedCurrency]?.flag"
                                  width="24"
                                  height="24"
                                  alt=""
                                  class="rounded"
                                />
                                <h4 class="ml-2 font-weight-bold">{{ selectedCurrency }}</h4>
                              </div>
                            </template>
                          </v-text-field>
                          <v-text-field
                            outlined
                            :label="`A ${currencyMap[supplier?.sAccountCurrency]?.name}`"
                            type="number"
                            dense
                            hide-details
                            :loading="isLoadingRate"
                            v-if="selectedCurrency != (supplier?.sAccountCurrency)"
                            :disabled="selectedCurrency != (supplier?.sAccountCurrency) ? isLoadingRate : false"
                            v-model="amounts[supplier?.sAccountCurrency]"
                            @change="(calculatorAmount(amounts[supplier?.sAccountCurrency], true, selectedCurrency, supplier?.sAccountCurrency))"
                            prefix="$"
                            class="mt-4"
                          >
                            <template v-slot:append>
                              <div class="d-flex align-center">
                                <img
                                  :src="currencyMap[supplier?.sAccountCurrency]?.flag"
                                  width="24"
                                  height="24"
                                  alt=""
                                  class="rounded"
                                />
                                <h4 class="ml-2 font-weight-bold">{{ supplier?.sAccountCurrency }}</h4>
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- Detalle de montos -->
                    <div class="py-6" v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-row class="align-center">
                        <v-col>
                          <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                            {{ "Total origin" }}
                          </div>
                        </v-col>
                        <v-col class="d-flex justify-end">
                          <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold';">
                            ${{ amounts[selectedCurrency] ? formatMoney(amounts[selectedCurrency]) : 0 }} {{ selectedCurrency }}
                          </h2>
                        </v-col>
                      </v-row>
                      <v-row class="align-center mt-0">
                        <v-col>
                          <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                            {{ selectedCurrency == (supplier?.sAccountCurrency) ? "Cantidad a enviar" : "Total destination" }}
                          </div>
                        </v-col>
                        <v-col class="d-flex justify-end">
                          <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold';">
                            ${{ amounts[supplier?.sAccountCurrency] ? formatMoney(amounts[supplier?.sAccountCurrency]) : 0 }} {{ supplier?.sAccountCurrency }}
                          </h2>
                        </v-col>
                      </v-row>
                    </div>

                    <div class="info-block" v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-textarea
                        class="pa-4"
                        rows="2"
                        :label="'Concepto de pago'"
                        v-model="comment"
                        no-resize
                        hide-details
                      ></v-textarea>
                    </div>

                    <!-- Spot o Window Spot -->
                    <div v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : false)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <v-card class="d-flex pa-2 mb-3" @click="selectedTypeOfPayment = 'Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; height: 100%;">
                            <div>
                              <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Pago instantaneo" }}</div>
                              <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                                {{ "Al utilizar pago instantaneo se descontara del balance origen y se enviara a la wallet destino." }}
                              </div>
                            </div>
                            <v-icon v-if="selectedTypeOfPayment === 'Spot'" color="black">mdi-check-circle</v-icon>
                            <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card class="d-flex pa-2" @click="selectedTypeOfPayment = 'Window Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; height: 100%;">
                            <div>
                              <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Pago diferido" }}</div>
                              <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                                {{ "Al utilizar pago diferido se creara un window spot y le permitira depositar el monto origen y una vez se refleje se enviara a tu destinatario." }}
                              </div>
                            </div>
                            <v-icon v-if="selectedTypeOfPayment === 'Window Spot'" color="black">mdi-check-circle</v-icon>
                            <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      @click="selectedCurrency = null, dialogSendPayWithTransaction = false, sTransactionId = null, selected = null, supplier = null, amounts = { USD: 0, MXN: 0 }, exchangeRateToday = '', exchangeRateTodayReference = '', selectedTypeOfPayment = null, comment = ''"
                    >
                      {{ "Cancel" }}
                    </v-btn>
                    <v-btn
                      color="black"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="selectedCurrency === null || amounts[selectedCurrency] == 0 || amounts[supplier?.sAccountCurrency] == 0 || (selectedCurrency != (supplier?.sAccountCurrency) ? selectedTypeOfPayment == null : false) || comment == '' || amounts[selectedCurrency] > avaibleAmount"
                      @click="e1 = 2"
                    >
                      {{ "Next" }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" class="pt-0">
              <v-card class="pa-6 mx-auto">
                <v-card-text class="pb-0 px-0" >
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="supplier">
                        <p class="label">Número de cuenta:</p>
                        <p class="value" >{{ "*" + (supplier ? (supplier?.sAccountNumber ? (supplier?.sAccountNumber).slice(-4) : (supplier?.accountNumber).slice(-4)) : '') }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else style="align-items: center;">
                          <v-chip v-if="selectedTypeOfPayment == 'Spot'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Spot" }}
                          </v-chip>
                          <v-chip v-else-if="selectedTypeOfPayment == 'Window Spot'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de pago:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[supplier?.sAccountCurrency]) + " " + (supplier?.sAccountCurrency) }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Payment concept:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="e1 = 1"
                  >
                    {{ "Back" }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    @click="sendPayment(), e1 = 3"
                  >
                    {{ "Confirm" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3" class="pt-0">
              <v-btn icon @click="dialogSendPayWithTransaction = false, sTransactionId = null, selectedCurrency = null, selected = null, selectedTypeOfPayment = '', comment = '', amounts = { MXN: null, USD: null }, paymentError = false, loadingPayment = false, getClient(), e1 = 1" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-card class="pa-6 mx-auto">
                <div v-if="loadingPayment" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando pago...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ selectedTypeOfPayment === 'Window Spot' ? "Pago programado correctamente!" : "Pago procesado correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al procesar el pago!
                  </v-card-title>
                </div>
                <v-card-text class="pb-0 px-0">
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="supplier">
                        <p class="label">Número de cuenta:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "*" + (supplier ? ((supplier?.accountNumber ? (supplier?.accountNumber).slice(-4) : (supplier?.sAccountNumber).slice(-4))) : '') }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else style="align-items: center;">
                          <v-chip v-if="selectedTypeOfPayment == 'Spot'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Forex" }}
                          </v-chip>
                          <v-chip v-else-if="selectedTypeOfPayment == 'Window Spot'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de pago:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[supplier?.sAccountCurrency]) + " " + (supplier?.sAccountCurrency) }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Payment concept:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogConvert" v-model="dialogConvert" persistent max-width="680" class="pa-8">
      <v-card>
        <v-stepper v-model="e1">
          <v-stepper-header
            color="black"
            v-if="e1 < 3" 
            class="mt-5 mr-15 ml-15"
            elevation="0"
            style="
              justify-content: center;
              align-items: center;
              justify-items: center;
              align-content: center;
              box-shadow: none;
            "
          >
            <v-stepper-step :complete="e1 > 1" step="1" color="black"> </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="black"> </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ "Cliente: " + enterprise.enterprise?.enterprise[0]?.sName }}</span> 
                </v-card-title>
                <v-card-text class="py-0" v-if="!loading">
                  <v-row class="mt-0">
                    <v-col>
                      <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Selecciona el tipo de conversión." }}</h4>
                    </v-col>
                  </v-row>
                  <v-row class="mt-0">
                    <v-col>
                      <v-autocomplete
                        v-model="selectedCard"
                        filled
                        rounded
                        :items="conversionTypes"
                        item-text="name"
                        item-value="id"
                        label="Selecciona el tipo de conversion"
                        hide-details
                        :item-disabled="isConversionDisabled"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <template v-if="selectedCard">
                    <v-row class="mt-0">
                      <v-col>
                        <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa el UUID del TC o genera uno." }}</h4>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0" style="display: flex; align-items: center;">
                      <v-col>
                        <v-text-field
                          v-model="exchangeRateTodayReference"
                          filled
                          @change="calculatorAmount(amounts[baseCurrency], false, baseCurrency, targetCurrency)"
                          :disabled="selectedCard === null"
                          rounded
                          label="Ingresa el UUID"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-btn
                          color="black"
                          class="my-4 mx-4 py-5 white--text"
                          elevation="2"
                          style="width: 204px; border-radius: 36px;"
                          :disabled="isLoadingRate"
                          rounded
                          @click="getRate(baseCurrency, targetCurrency)"
                        >
                          <span style="font-family: 'montserrat-semibold';">{{ "Generar UUID" }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-if="selectedCard === 3 && exchangeRateTodayReference">
                    <v-row class="mt-0">
                      <v-col>
                        <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa la fecha del Forward" }}</h4>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col>
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="dDateForward"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="dDateForward"
                              :label="'selectDateForward'"
                              prepend-inner-icon="mdi-calendar"
                              hide-details
                              :disabled="exchangeRateTodayReference === ''"
                              rounded
                              filled
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dDateForward"
                            :min="today"
                            :allowed-dates="onlyWeekdays"
                            :max="limit"
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog.save(dDateForward), dDateForward != null ? getForwardRate(0, false) : null, amounts = { MXN: null, USD: null }"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>

                        {{ dDateForward }}
                      </v-col>
                    </v-row>
                  </template>
                  <v-row v-if="selectedCard && exchangeRateTodayReference">
                    <v-col style="display: flex; justify-content: center;">
                      <div class="px-4 py-2" style="display: flex; background-color: #D9D9D9; border-radius: 30px; width: fit-content;">
                        <div class="d-flex align-center px-2" style="background-color: #FFFFFF; border-radius: 20px;">
                          <img
                            :src="currencyMap[baseCurrency]?.flag"
                            width="34"
                            height="24"
                            style="border-radius: 20px;"
                            alt=""
                          />
                          <h4 class="ml-2 font-weight-bold">{{ baseCurrency }}</h4>
                        </div>
                        <v-btn color="black" icon :disabled="exchangeRateToday === ''" @click="swapCurrencies()">
                          <v-icon color="black">mdi-swap-horizontal</v-icon>
                        </v-btn>
                        <div class="d-flex align-center px-2" style="background-color: #FFFFFF; border-radius: 20px;">
                          <img
                            :src="currencyMap[targetCurrency]?.flag"
                            width="34"
                            height="24"
                            style="border-radius: 20px;"
                            alt=""
                          />
                          <h4 class="ml-2 font-weight-bold">{{ targetCurrency }}</h4>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="selectedCard && exchangeRateTodayReference">
                    <v-col>
                      <div class="info-block" style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                        <template v-if="isLoadingRate">
                          <v-progress-circular indeterminate color="primary" size="64" width="6" class="mt-3" />
                          <p style="margin-top: 16px; font-weight: bold;">Obteniendo tipo de cambio...</p>
                        </template>
                        <template v-else>
                          <p class="label">Tipo de cambio:</p>
                          <p class="value">{{ exchangeRateToday ? "$" + exchangeRateToday + " MXN" : "-" }}</p>
                        </template>
                      </div>
                    </v-col>
                  </v-row>
                  <template v-if="selectedCard && exchangeRateTodayReference">
                    <v-row class="mt-0">
                      <v-col>
                        <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa el monto a convertir" }}</h4>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col>
                        <v-text-field
                        outlined
                        :label="`De ${currencyMap[baseCurrency]?.name}`"
                        type="number"
                        dense
                        hide-details
                        :disabled="selectedCard === 3 && !dDateForward || isLoadingRate || exchangeRateToday === '' || isLoadingAmount"
                        v-model="amounts[baseCurrency]"
                        @change="selectedCard != 3 ? calculatorAmount(amounts[baseCurrency], false, baseCurrency, targetCurrency) : getForwardRate(amounts[baseCurrency], false)"
                        prefix="$"
                        class="mb-7"
                      >
                        <template v-slot:append>
                          <div class="d-flex align-center">
                            <img
                              :src="currencyMap[baseCurrency]?.flag"
                              width="24"
                              height="24"
                              alt=""
                              class="rounded"
                            />
                            <h4 class="ml-2 font-weight-bold">{{ baseCurrency }}</h4>
                          </div>
                        </template>
                      </v-text-field>
                      <v-text-field
                        outlined
                        :label="`A ${currencyMap[targetCurrency]?.name}`"
                        type="number"
                        :disabled="selectedCard === 3 && !dDateForward || isLoadingRate || exchangeRateToday === '' || isLoadingAmount"
                        dense
                        hide-details
                        v-model="amounts[targetCurrency]"
                        @change="selectedCard != 3 ? calculatorAmount(amounts[targetCurrency], true, baseCurrency, targetCurrency) : getForwardRate(amounts[targetCurrency], true)"
                        prefix="$"
                        class="mb-5"
                      >
                        <template v-slot:append>
                          <div class="d-flex align-center">
                            <img
                              :src="currencyMap[targetCurrency]?.flag"
                              width="24"
                              height="24"
                              alt=""
                              class="rounded"
                            />
                            <h4 class="ml-2 font-weight-bold">{{ targetCurrency }}</h4>
                          </div>
                        </template>
                      </v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-if="selectedCard && exchangeRateTodayReference">
                    <v-row class="align-center mt-1">
                      <v-col class="pb-0">
                        <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                          {{ "Total origin" }}
                        </div>
                      </v-col>
                      <v-col class="pb-0 d-flex justify-end">
                        <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                          ${{ amounts[baseCurrency] ? formatMoney(amounts[baseCurrency]) : 0 }} {{ baseCurrency }}
                        </h2>
                      </v-col>
                    </v-row>
                    <v-row class="align-center mt-5 mb-4">
                      <v-col class="pb-0">
                        <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                          {{ "Total destino" }}
                        </div>
                      </v-col>
                      <v-col class="pb-0 d-flex justify-end">
                        <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                          ${{ amounts[targetCurrency] ? formatMoney(amounts[targetCurrency]) : 0 }} {{ targetCurrency }}
                        </h2>
                      </v-col>
                    </v-row>
                  </template>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    color="black"
                    elevation="8"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined 
                    :disabled="loading"
                    @click="dialogConvert = false, selectedCard = null, amounts = { MXN: 0, USD: 0 }, exchangeRateToday = null, exchangeRateTodayReference = null, dDateForward = null"
                  >
                    {{ "Cancel" }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading || isLoadingAmount || isLoadingRate"
                    :disabled="selectedCard === null"
                    @click="e1 = 2"
                  > 
                    {{ "Continue" }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" class="pt-0">
              <v-card class="px-6 py-0 mx-auto" :width="selectedCard === 2 ? 500 : 900">
                <v-card-title class="pt-0 text-center font-weight-bold text-textblack" style="display: flex; justify-content: center">
                  {{ "Detalle del " + (selectedCard === 2 ? "Spot" : (selectedCard === 3 ? "Forward" : "Window Spot")) }}
                </v-card-title>
                <v-card-text class="pb-0">
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <p class="value">
                          <v-chip v-if="selectedCard == 2" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Forex" }}
                          </v-chip>
                          <v-chip v-else-if="selectedCard == 3" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                            {{ "Forward" }}
                          </v-chip>
                          <v-chip v-else-if="selectedCard == 4" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de conversión:</p>
                        <p class="value">{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedCard === 3" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha programada:</p>
                        <p class="value">{{ dDateForward }}</p>
                      </div>
                      <div v-if="selectedCard === 4" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <p class="value">{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div v-if="selectedCard === 3" class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                      <div class="mr-4" style="border-right: black solid 4px; height: 120px"></div>
                      <div style="display: flex; flex-direction: column;">
                        <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
                          Al programar un Forward tienes que cumplir con las siguientes dos condiciones:
                        </div>
                        <ul style="padding-left: 16px; margin: 0; font-family: 'montserrat-semibold'; font-size: 14px; color: #2E404E;">
                          <li>La fecha seleccionada es la fecha en la cual se ejecutará el pago pactado. La carga de fondos debe efectuarse previo al fin del plazo.</li>
                          <li>Tendrás que hacer un depósito del 5% de los fondos totales del Futuro, los cuales serán restados de tu balance origen.</li>
                        </ul>
                      </div>
                    </div>
                    <div v-if="selectedCard === 4" class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                      <div class="mr-4" style="border-right: black solid 4px; height: 120px"></div>
                      <div style="display: flex; flex-direction: column;">
                        <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
                          Al programar un Window Spot tienes que cumplir con las siguientes condiciones:
                        </div>
                        <ul style="padding-left: 16px; margin: 0; font-family: 'montserrat-semibold'; font-size: 14px; color: #2E404E;">
                          <li>Depositar el 100% del monto origen dentro de un plazo de 7 días. Este monto será descontado de tu balance al ingresarlo y convertido al monto destino.</li>
                        </ul>
                      </div>
                    </div>
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <p class="value">{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCard === 3" style="display: flex; justify-content: space-between;">
                        <p class="label">5% of the total Forward funds:</p>
                        <p class="value">{{ "$ " + formatMoney((amounts[baseCurrency] * .05)) + " " + baseCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <p class="value">{{ "$ " + formatMoney(amounts[baseCurrency]) + " " + baseCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Monto destino:</p>
                        <p class="value">{{ "$ " + formatMoney(amounts[targetCurrency]) + " " + targetCurrency }}</p>
                      </div>
                    </div>
                    <div v-if="selectedCard === 3" class="mb-0" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                      <div class="mr-4" style="border-right: #FCCA3D solid 4px; height: 120px"></div>
                      <div style="display: flex; flex-direction: column;">
                        <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
                          {{ 'Por favor carga los fondos correspondientes antes o en la fecha del vencimiento' }}
                        </div>
                        <ul style="padding-left: 16px; margin: 0; font-family: 'montserrat-semibold'; font-size: 14px; color: #2E404E;">
                          <div>{{ 'Si el pago no cuenta con los fondos para la fecha indicada' }} {{ 'En caso de no cumplir con el pago de la operación pactada, se deberá cubrir el diferencial entre la tipo de cambio de esa fecha y la pactada inicialmente.' }}</div>
                          <v-checkbox color="primary" v-model="acceptWarranty" hide-details class="pb-5">
                            <template v-slot:label>
                              <div style="font-family: 'montserrat-semibold'; font-size: 14px; color: #2E404E;">
                                {{ 'Necesitarás disponer el 5% de los fondos totales del Futuro ahora, el monto a depositar es de' }} <span style="font-size: 18px; font-weight: bold;">{{ "$ " + formatMoney((amounts[baseCurrency] * .05)) + " " + baseCurrency }}</span> {{ 'el monto se restará de tu balance origen.' }}
                              </div>
                            </template>
                          </v-checkbox>
                        </ul>
                      </div>
                    </div>
                  </v-card>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      color="black"
                      elevation="4"
                      class="mr-2 px-10"
                      style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      :disabled="loading"
                      @click="e1 = 1"
                    >
                      {{ "Back" }}
                    </v-btn>
                    <v-btn
                      color="black"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="!amounts[baseCurrency] || isLoading || (selectedCard === 3 && !acceptWarranty)"
                      @click="createConversion(), e1 = 3"
                    > 
                      {{ "Confirm" }}
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3" class="pt-0">
              <v-btn icon @click="dialogConvert = false, e1 = 1, amounts = { MXN: null, USD: null }, exchangeRateToday = null, exchangeRateTodayReference = null, dForwardTransactionDate = null, conversionError = false, loadingConversion = false, getClient()" :disabled="loadingConversion" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-card class="pa-6 mx-auto">
                <div v-if="loadingConversion" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando conversión...</p>
                </div>
                <div v-if="conversionError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ (selectedCard === 2 ? "Spot" : (selectedCard === 3 ? "Forward" : "Window Spot")) + " realizado correctamente!"}}
                  </v-card-title>
                </div>
                <div v-if="conversionError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al realizar la conversion!
                  </v-card-title>
                </div>

                <v-card-text class="pb-0 px-0 pt-0">
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>
                          <v-chip v-if="selectedCard == 2" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Forex" }}
                          </v-chip>
                          <v-chip v-else-if="selectedCard == 3" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                            {{ "Forward" }}
                          </v-chip>
                          <v-chip v-else-if="selectedCard == 4" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de conversión:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedCard === 3" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha programada:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ dDateForward }}</p>
                      </div>
                      <div v-if="selectedCard === 4" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCard === 3" style="display: flex; justify-content: space-between;">
                        <p class="label">5% of the total Forward funds:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney((amounts[baseCurrency] * .05)) + " " + baseCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[baseCurrency]) + " " + baseCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Monto destino:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[targetCurrency]) + " " + targetCurrency }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-if="createBeneficiary" v-model="createBeneficiary" persistent max-width="680">
      <v-card>
        <v-stepper v-model="step" alt-labels elevation="0">
          <v-stepper-header color="black" class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;">
            <v-stepper-step :complete="step > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <!-- Paso 1: Crear un proveedor -->
            <v-stepper-content step="1" elevation="0" class="pt-0" style="width: 680px;">
              <div class="mb-6" style="text-align: center; font-family: 'montserrat-bold'; font-size: 20px;">{{ existingAccountType ? 'Actualizar cuenta' : 'Crear beneficiario' }}</div>
              <v-card-text v-if="!loading">
                <v-container>
                  <v-row>
                    <v-form ref="formNew" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            :label="'Nombre del beneficiario *'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sName"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-select
                            :label="'Pais *'"
                            required
                            hide-details
                            outlined
                            :items="country"
                            style="border-radius: 10px"
                            v-model="forms.new.sCountry"
                            :rules="[rules.required]"
                            :readonly="selectedAccountType === 'retiro' || selectedAccountType === 'window_spot_mxn' || selectedAccountType === 'window_spot_usd'"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="pb-4">
                          <v-text-field
                            :label="'Email *'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sEmail"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <div class="mb-4" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 20px;">
                        <div class="ml-4" style="border-right: #FCCA3D solid 4px; height: 40px"></div>
                        <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Por favor, asegúrese de que el nombre de la empresa coincide exactamente con el nombre registrado oficialmente en la empresa." }}</div>
                      </div>
                      <div v-if="forms.new.sCountry === 'USA'">
                        <div class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 20px;">
                          <div class="ml-4" style="border-right: black solid 4px; height: 40px"></div>
                          <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "La dirección debe ser del domicilio del beneficiario y no del banco receptor." }}</div>
                        </div>
                        <v-row>
                          <v-col cols="6" class="pb-0">
                            <v-text-field
                              :label="'Dirección' + '*'"
                              required
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sAddress"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pb-0">
                            <v-text-field
                              :label="'Código Postal' + '*'"
                              required
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.postCode"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row style="margin-top: -10px;">
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Ciudad' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sCity"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Estado' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sState"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-row>
                </v-container>
              </v-card-text>
              <div v-else style="display: flex; justify-content: center;">
                <v-progress-circular
                  indeterminate
                  color="amber"
                ></v-progress-circular>
              </div>
              <v-card-actions class="pb-4" style="justify-content: space-evenly;">
                <v-btn
                  color="black"
                  elevation="8"
                  class="mr-2 px-6"
                  style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  :disabled="loading"
                  @click="createBeneficiary = false, forms.new = { sName: '', sEmail: '', sBank_name: '', sAccount_number: '', clabe: '', sCountry: '', currency: '', sTaxId: '', accountType: '', sState: '', sCity: '', sAddress: '', transferMethod: '' }"
                >
                  {{ 'Cancel' }}
                </v-btn>
                <v-btn
                  color="black"
                  elevation="8"
                  class="white--text px-6"
                  style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
                  @click="nextStep()"
                >
                  {{ 'Continue' }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
            <!-- Paso 1: Crear un proveedor -->
            <v-stepper-content step="2" elevation="0" class="pt-0" style="width: 680px;">
              <v-card-text v-if="!loading">
                <v-container>
                  <v-row v-if="forms.new.sCountry === 'MX'">
                    <v-form ref="formSecondStep" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="'Nombre de banco *'"
                            required
                            style="border-radius: 10px"
                            outlined
                            v-model="forms.new.sBank_name"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-select
                            :label="'Currency Account *'"
                            required
                            outlined
                            :items="currency"
                            style="border-radius: 10px"
                            v-model="forms.new.currency"
                            :rules="[rules.required]"
                            :readonly="selectedAccountType === 'retiro' || selectedAccountType === 'window_spot_mxn' || selectedAccountType === 'window_spot_usd'"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="'Numero de cuenta *'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.clabe"
                            :rules="[rules.required, rules.clabeLength]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="'RFC'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sTaxId"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <div v-if="forms.new.currency === 'USD'">
                        <div class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 20px;">
                          <div class="ml-4" style="border-right: #0075B8 solid 4px; height: 40px"></div>
                          <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "La dirección debe ser del domicilio del beneficiario y no del banco receptor." }}</div>
                        </div>
                        <v-row>
                          <v-col cols="12" class="pb-2">
                            <v-text-field
                              :label="'Dirección' + '*'"
                              required
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sAddress"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row style="margin-top: -5px;">
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Ciudad' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sCity"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Estado' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sState"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-row>
                  <v-row v-else>
                    <v-form ref="formUSDSecondStep" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="'Nombre de banco *'"
                            required
                            style="border-radius: 10px"
                            outlined
                            v-model="forms.new.sBank_name"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            label="Account number *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sAccount_number"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <div class="mb-8" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 20px;">
                        <div class="ml-4" style="border-right: #FCCA3D solid 4px; height: 40px"></div>
                        <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Por favor, asegúrate de ingresar el número de routing adecuado según el tipo de cuenta (wire/ACH)." }}</div>
                      </div>
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <v-text-field
                            label="Routing Number *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.routingNumber"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <v-select
                            :label="'Account type' + '*'"
                            required
                            outlined
                            :items="accountType"
                            item-text="text"
                            item-value="value"
                            style="border-radius: 10px"
                            v-model="forms.new.accountType"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="pt-0">
                          <v-select
                            :label="'Transfer method' + '*'"
                            required
                            outlined
                            :items="transferMethod"
                            style="border-radius: 10px"
                            item-value="id"
                            item-text="name"
                            v-model="forms.new.transferMethod"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <div class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 20px;">
                        <div class="ml-4" style="border-right: #0075B8 solid 4px; height: 80px"></div>
                        <div style="display: flex; flex-direction: column;">
                          <div class="px-4 pt-3 pb-3" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Los pagos vía Wire se procesan en aproximadamente 30 a 60 minutos (dentro del horario bancario) y los pagos ACH pueden demorar entre 1 y 3 días hábiles. " }}</div>
                          <div class="px-4 pb-3" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Se aplicará un cargo por comisión (FEE) de $12.50 USD al utilizar wire." }}</div>
                        </div>
                      </div>
                    </v-form>
                  </v-row>
                </v-container>
              </v-card-text>
              <div v-else style="display: flex; justify-content: center;">
                <v-progress-circular
                  indeterminate
                  color="black"
                ></v-progress-circular>
              </div>
              <v-card-actions class="pb-4" style="justify-content: space-evenly;">
                <v-btn
                  color="black"
                  elevation="8"
                  class="mr-2 px-6"
                  style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  :disabled="loading"
                  @click="step = 1, forms.new.currency = ''"
                >
                  {{ "Back" }}
                </v-btn>
                <v-btn
                  color="black"
                  elevation="8"
                  :disabled="loading"
                  class="white--text px-6"
                  style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
                  @click="selectedAccountType === 'retiro' ? saveWithdrawalAccount() : selectedAccountType === 'window_spot_mxn' ? saveWindowMXNAccount() : selectedAccountType === 'window_spot_usd' ? saveWindowUSDAccount() : saveBeneficiary()"
                >
                  {{ "Confirm" }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogRequestPayment" v-model="dialogRequestPayment" persistent max-width="fit-content">
      <v-card>
        <v-card-title class="text-h5" style="font-family: 'montserrat-bold' !important;">{{ '¿Estás seguro de que deseas solicitar el pago total del forward?' }}</v-card-title>
        <v-card-text v-if="!loading" class="mt-6" style="font-family: 'montserrat-semibold';">
          {{ 'Una vez que realizas la transacción se revisará que tu saldo USD sea suficiente para pagar el total del forward.' }}
        </v-card-text>
        <v-card-text v-if="!loading" class="mb-6" style="font-family: 'montserrat-semibold';">
          {{ 'El monto se irá a la pestaña de saldo disponible MXN.' }}
        </v-card-text>
        <div v-else style="display: flex; justify-content: center;">
          <v-progress-circular indeterminate color="#193D6E"></v-progress-circular>
        </div>
         <v-card-actions class="pb-4" style="justify-content: space-evenly;">
          <v-btn
            color="black"
            elevation="8"
            class="mr-2 px-6"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loading"
            @click="dialogRequestPayment = false, forward = null"
          >
            {{ 'Cancel' }}
          </v-btn>
          <v-btn
            color="black"
            elevation="8"
            class="white--text px-6"
            style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
            @click="requestPayment()"
          >
            {{ 'Confirm' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogCreateAlert" v-model="dialogCreateAlert" persistent class="pa-8" max-width="450">
      <v-card>
        <v-card-title class="pl-16" style="color: #193D6E; font-weight: bold">
          <span style="font-size: 24px;">{{ 'Crear alerta' }}</span>
        </v-card-title>
        <v-card-subtitle class="pl-16 pt-2">
          <v-icon color="#12A150">mdi-trending-up</v-icon> <span style="color: #12A150;">1 USD = {{ exchangeRateToday ? exchangeRateToday : 0 }} MXN</span>
        </v-card-subtitle>
        <v-card-text>
         <v-container class="d-flex justify-center" style="color: black; font-size: 16px; font-weight: 500;">
          {{ 'Notificarme cuando el precio de USD llegue a' }}
         </v-container>

         <v-container class="d-flex justify-center px-12">
          <v-text-field
            type="number"
            v-model="targetPrice"
            color="black"
            solo
            :suffix="'Precio objetivo'"
            class="mb-5"
            style="border-radius: 10px; color: #737583;"
            hide-spin-buttons
            :autofocus="false"
          >
            <template #prepend-inner>
              <img src="../../assets/images/mx-flag.png" alt="Custom Icon" style="width: 26px; height: 20px;" />
            </template>
          </v-text-field>
         </v-container>

         <v-container class="d-flex justify-center">
          <v-row class="d-flex justify-center">
            <v-col class="d-flex justify-center">
              <v-btn color="#FFFFFF" rounded class="d-flex align-center" @click="dialogCreateAlert = false, targetPrice = null, isLoadingAlertsCreate = false" style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;">
                <span style="color: black; text-transform: none; font-size: 16px;">{{ 'Cancelar' }}</span>
              </v-btn>
            </v-col>
            <v-col class="d-flex justify-center">
              <v-btn
              color="black"
              rounded
              class="d-flex align-center"
              @click="createAlert()"
              :loading="isLoadingAlertsCreate || isLoadingRate"
              style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); width: 150px;"
            >
              <template v-slot:loader>
                <v-progress-circular
                  indeterminate
                  :size="20"
                  style="color: white;"
                ></v-progress-circular>
              </template>
              <span style="color: white; text-transform: none; font-size: 16px;">{{ 'Crear' }}</span>
            </v-btn>
            </v-col>
          </v-row>
         </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogSelectAccountType" v-model="dialogSelectAccountType" persistent max-width="900px">
      <v-card style="border-radius: 20px; padding: 40px;">
        <v-btn icon @click="dialogSelectAccountType = false, selectedAccountType = null" style="position: absolute; top: 20px; left: 20px;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-card-title class="justify-center mb-8" style="font-family: 'montserrat-bold'; font-size: 28px;">
          Selecciona el tipo de cuenta a {{ (selectedAccountType === 'retiro' && activeAccounts.retiro) || (selectedAccountType === 'window_spot_mxn' && activeAccounts.mxn) || (selectedAccountType === 'window_spot_usd' && activeAccounts.usd) ? 'actualizar' : 'crear' }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" v-for="accountType in accountTypes" :key="accountType.id" class="py-2">
                <v-card
                  @click="selectedAccountType = accountType.id"
                  :class="['account-type-card', { 'selected': selectedAccountType === accountType.id }]"
                  style="cursor: pointer; border-radius: 20px; padding: 30px; text-align: left; transition: all 0.3s; border: 2px solid #E0E0E0;"
                  elevation="0"
                  hover
                >
                  <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                    <div style="flex: 1;">
                      <h3 style="font-family: 'montserrat-bold'; font-size: 18px; margin-bottom: 10px; color: #000;">
                        {{ accountType.title }}
                      </h3>
                      <p style="font-family: 'montserrat-regular'; font-size: 14px; color: #666; line-height: 1.5;">
                        {{ [accountType.id] ? 'Ya tienes una cuenta de este tipo. Al continuar, actualizarás la información existente.' : accountType.description }}
                      </p>
                    </div>
                    <v-icon
                      :color="selectedAccountType === accountType.id ? 'black' : '#E0E0E0'"
                      size="24"
                      style="margin-top: -5px;"
                    >
                      {{ selectedAccountType === accountType.id ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                    </v-icon>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center mt-4">
          <v-btn
            color="black"
            elevation="8"
            class="white--text px-8 py-6"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none; font-size: 16px;"
            @click="openCreateAccountFlow()"
            :disabled="!selectedAccountType"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogCreateInvoice" v-model="dialogCreateInvoice" persistent max-width="600px">
      <v-card>
        <v-card-title style="display: flex; justify-content: center">
          <span style="font-family: 'montserrat-bold'; font-size: 25px;">{{ 'Agregar factura' }}</span> 
        </v-card-title>
        <v-card-subtitle class="pb-4 mt-3" style="text-align: center;">
          <span style="font-family: 'montserrat-semibold'; font-size: 15px;">{{ 'Add the following information to add a new invoice.' }}</span>
        </v-card-subtitle>
        <v-card-text class="pb-1">
          <v-container>
            <v-row>
              <v-form
                ref="formNew"
                style="width: 100%"
                lazy-validation
                v-on:submit.prevent
              >
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Invoice *'" 
                      required
                      style="border-radius: 10px"
                      outlined
                      v-model="forms.new.sInvoice"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Purchase Order'"
                      required
                      style="border-radius: 10px"
                      outlined
                      v-model="forms.new.sId"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-autocomplete
                      :label="'Beneficiary *'" 
                      required
                      style="border-radius: 10px"
                      :items="paymentsRecipients"
                      outlined
                      item-text="sName"
                      return-object
                      v-model="forms.new.sSupplier"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Fecha de compra *'" 
                      required
                      style="border-radius: 10px"
                      outlined
                      type="date"
                      v-model="forms.new.dPurchaseDate"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      :label="(forms?.new?.sSupplier?.sAccountCurrency === 'MXN' ? 'Total amount MXN' : 'Total amount USD') + '*'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="forms.new.dTotalAmount"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Dias de credito *'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="forms.new.iCreditPeriod"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Tipo de cambio protegido *'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="forms.new.dRateProtection"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-row>
          </v-container>
          <small>{{'* indicates required field'}}</small>
        </v-card-text>
        <v-card-actions class="py-4 pb-6" style="justify-content: space-evenly;">
          <v-btn
            color="black"
            elevation="8"
            class="mr-2 px-10"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loading"
            @click="dialogCreateInvoice = false, forms.new = { sInvoice: '', sId: '', sSupplier: null, dPurchaseDate: '', dTotalAmount: '', dRateProtection: '', iCreditPeriod: '' }"
          >
            {{ 'Cancelar' }}
          </v-btn>
          <v-btn
            color="black"
            elevation="8"
            class="white--text px-10"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="loading"
            :loading="loading"
            @click="createInvoice()"
          > 
            {{ 'Confirm' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogPayInvoices" v-model="dialogPayInvoices" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header color="black" v-if="e1 < 3" class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;">
            <v-stepper-step :complete="e1 > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Paso 1: Detalle de pago -->
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">
                    {{ 'Selecciona la wallet desde la que desea utilizar los fondos.' }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 px-4" v-if="!loading" style="display: flex; align-items: center; width: fit-content; margin: auto; gap: 30px; flex-wrap: wrap; justify-content: center;">
                <v-card class="d-flex pa-6" outlined @click="selectedCurrency = 'USD'" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                        <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">{{ "Wallet USD" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="selectedCurrency === 'USD'" color="black">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceUsd ? balanceUsd : 0) }} USD
                    </div>
                  </div>
                </v-card>
                <v-card class="d-flex pa-6" outlined @click="selectedCurrency = 'MXN'" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                        <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">{{ "Wallet MXN" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="selectedCurrency === 'MXN'" color="black">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceMxn ? balanceMxn : 0) }} MXN
                    </div>
                  </div>
                </v-card>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="selectedCurrency = null, dialogPayInvoices = false"
                  >
                    {{ 'Cancelar' }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="selectedCurrency === null"
                    @click="openPayNow(selectedInvoice), e1 = 2"
                  > 
                    {{ 'Continuar' }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack" style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Detalle de pago' }}</span>
                </v-card-title>
                <v-card-text class="py-6 pb-0">
                  <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                    <v-card class="d-flex pa-6 mb-4" outlined elevation="2"
                      style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                    >
                      <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                        <div>
                          <div style="margin-right: 30px">
                            <v-img v-if="selectedCurrency == 'USD'" src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                            <v-img v-else src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                            <div style="font-size: 13px; font-family: 'montserrat-bold';">{{ selectedCurrency == 'USD' ? "Wallet USD" : "Wallet MXN" }}</div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                          ${{ formatMoney(selectedCurrency == 'USD' ? balanceUsd : balanceMxn) }} {{ selectedCurrency }}
                        </div>
                      </div>
                    </v-card>
                    <div style="max-width: 200px;">
                      <v-select
                        :label="'Sort exchange rate by'"
                        required
                        outlined
                        v-if="selectedCurrency == selectedDestCurrency"
                        :items="sortTypes"
                        style="border-radius: 10px"
                        v-model="sortType"
                      ></v-select>
                    </div>
                  </div>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Factura a pagar' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Nombre del beneficiario' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Número CLABE' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Cantidad a enviar' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'El destinatario recibirá' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Tipo de cambio' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Concepto de pago' }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="loadingCalculator">
                        <tr v-for="n in 3" :key="n">
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td></td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">{{ invoice.sInvoice }}</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">{{ invoice.supplier }}</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">{{ "********" + invoice.sAccountNumber }}</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">${{ formatMoney(invoice.dExchangeRate) }} MXN</td>
                          <td style="min-width: 200px;">
                            <v-text-field
                              v-model="invoice.comment"
                              dense
                              hide-details
                              class="pt-0 mt-0"
                              :placeholder="'Pago ' + invoice.sInvoice"
                              style="font-size: 13px; font-family: 'montserrat-bold';"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right" style="font-size: 13px; font-family: 'montserrat-bold';">Total:</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">${{ formatMoney(totalAmountOrigin) + " " + selectedCurrency}} </td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                          <td></td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn
                    color="black"
                    elevation="8"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="e1 = 1, selectedCurrency = null"
                  >
                    {{ 'Regresar' }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="8"
                    class="white--text px-10"
                    :disabled="loadingCalculator || totalAmountOrigin > parseFloat(selectedCurrency == 'USD' ? balanceUsd : balanceMxn)"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    @click="payInvoice(), e1 = 3"
                  >
                  {{ 'Continuar' }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <v-stepper-content step="3" elevation="0" class="pt-0">
              <v-btn icon @click="getClient(), e1 = 1, selectedInvoice = [], dialogPayInvoices = false, selectedCurrency = null, sortType = 'asc'" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="black">mdi-close</v-icon>
              </v-btn>
              <v-container class="mt-1">
                <div v-if="loadingPayment" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando pago...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193d6d; border-radius: 10px;">
                    {{ "Pago procesado correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al procesar el pago!
                  </v-card-title>
                </div>
                <v-card-text class="py-6 pb-0">
                  <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                    <div style="max-width: 200px;">
                      <v-select
                        :label="'Sort exchange rate by'"
                        required
                        disabled
                        outlined
                        v-if="selectedCurrency == selectedDestCurrency"
                        :items="sortTypes"
                        style="border-radius: 10px"
                        v-model="sortType"
                      ></v-select>
                    </div>
                  </div>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th>{{ 'Factura a pagar' }}</th>
                        <th>{{ 'Nombre del beneficiario' }}</th>
                        <th>{{ 'Número CLABE' }}</th>
                        <th>{{ 'Cantidad a enviar' }}</th>
                        <th>{{ 'El destinatario recibirá' }}</th>
                        <th>{{ 'Tipo de cambio' }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="loadingCalculator">
                        <tr v-for="n in 3" :key="n">
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td></td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td>{{ invoice.sInvoice }}</td>
                          <td>{{ invoice.supplier }}</td>
                          <td>{{ "********" + invoice.sAccountNumber }}</td>
                          <td>${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td>${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td>${{ formatMoney(invoice.dExchangeRate) }} MXN</td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountOrigin) + " " + selectedCurrency}} </td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogConvertInvoices" v-model="dialogConvertInvoices" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header color="black" v-if="e1 < 3" class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;">
            <v-stepper-step :complete="e1 > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Paso 1: Selección de tarjeta -->
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ 'Selecciona el tipo de conversión' }}</span> 
                </v-card-title>
                <v-card-text class="py-6 pb-0" v-if="!loading">
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" outlined :class="{ 'selected-card': selectedCard === 2 }" @click="selectedCard = 2" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ 'Convierte pago a MXN' }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify">{{ "Convierte tus USD a MXN, luego decide cuándo pagar a tu beneficiario" }}</div>
                      </div>
                      <v-icon v-if="selectedCard === 2" color="black">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" :disabled="true" outlined :class="{ 'selected-card': selectedCard === 3 }" @click="selectedCard = 3" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ 'Pago a Futuro' }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify"> {{isDisabledForward ? 'Los futuros solo se procesan de 9 a.m. a 4 p.m. (CDMX, GMT-6) por horario bancario' : 'Protégete de fluctuaciones cambiarias' }}</div>
                      </div>
                      <v-icon v-if="selectedCard === 3" color="black">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn 
                    color="black"
                    elevation="8"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="dialogConvertInvoices = false, selectedCard = null, e1 = 1"
                  >
                    {{ 'Cancelar' }}
                  </v-btn>
                  <v-btn 
                    color="black"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    @click="openPayNow(selectedInvoice), e1 = 2"
                    :disabled="selectedCard === null"
                  >
                    {{ 'Continuar'}}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <!-- Paso 2: Detalles según selección -->
            <v-stepper-content step="2" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ selectedCard === 2 ? 'Detalle de la conversión' : 'Detalle del Futuro' }}</span>
                </v-card-title>
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <v-card class="d-flex pa-6 mb-4" outlined elevation="2"
                    style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                  >
                    <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                      <div>
                        <div style="margin-right: 30px">
                          <v-img v-if="baseCurrency == 'USD'" src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                          <v-img v-else src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                          <div class="usd-balance">{{ baseCurrency == 'USD' ? "Wallet USD" : "Wallet MXN" }}</div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                        ${{ formatMoney(baseCurrency == 'USD' ? balanceUsd : balanceMxn) }} {{ selectedCurrency }}
                      </div>
                    </div>
                  </v-card>
                  <div style="max-width: 200px;">
                    <v-select
                      :label="'Sort exchange rate by'"
                      required
                      outlined
                      v-if="selectedCurrency == selectedDestCurrency"
                      :items="sortTypes"
                      style="border-radius: 10px"
                      v-model="sortType"
                    ></v-select>
                  </div>
                </div>
                <v-card-text class="pt-4 pb-0 px-0">
                  <div v-if="selectedCard === 3" class="pt-4 px-4 mb-4" style="display: flex; justify-content: center; background-color: #e5f6fd; flex-direction: row; border-radius: 15px;">
                    <div>
                      <v-icon color="#2c93d6" style="margin-right: 12px">mdi-alert-octagon-outline</v-icon>
                    </div>
                    <div>
                      <p style="font-size: 16px; font-weight: 700; color: #014361">{{ 'Al programar un Futuro tienes que cumplir con las siguientes dos condiciones:' }}</p>
                      <p style="font-size: 14px; font-weight: 500; color: #014361" class="mb-0">{{ 'La fecha seleccionada es la fecha en la cual se ejecutará el pago pactado. La carga de fondos debe efectuarse previo al fin del plazo.' }}</p>
                      <v-divider class="my-4"></v-divider>
                      <p style="font-size: 14px; font-weight: 500; color: #014361">{{ 'Tendrás que hacer un depósito del 5% de los fondos totales del Futuro, los cuales serán restados de tu balance origen.' }}</p>
                    </div>
                  </div>
                  <v-simple-table>
                    <template v-if="loadingCalculator">
                        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
                    </template>
                    <template v-else>
                      <thead>
                        <tr>
                          <th>{{ 'Factura a convertir' }}</th>
                          <th>{{ 'Nombre del beneficiario' }}</th>
                          <th>{{ 'Número CLABE' }}</th>
                          <th>{{ 'Cantidad a enviar' }}</th>
                          <th>{{ 'El destinatario recibirá' }}</th>
                          <th>{{ 'Tipo de cambio' }}</th>
                          <th v-if="selectedCard === 3">Forward Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td>{{ invoice.sInvoice }}</td>
                          <td>{{ invoice.supplier }}</td>
                          <td>{{ "********" + invoice.sAccountNumber }}</td>
                          <td>${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td>${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td>${{ selectedCard == 2 ? formatMoney(invoice.dExchangeRate) : (invoice.dForwardExchangeRate ? formatMoney(invoice.dForwardExchangeRate) : "") }} MXN</td>
                          <td v-if="selectedCard === 3">
                            <v-dialog v-if="dialogConvert" ref="dialog" v-model="invoice.modal" width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn text :color="invoice.dForwardDate ? 'primary' : 'grey'" v-bind="attrs" v-on="on">
                                  {{ invoice.dForwardDate ? formatDate(invoice.dForwardDate) : "Select Date" }}
                                </v-btn>
                              </template>
                              <v-date-picker v-model="invoice.dForwardDate" :min="today" :allowed-dates="onlyWeekdays" :max="limit" scrollable @input="getForwardRate(invoice)">
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="closeDatePicker(invoice)"
                                  >
                                  Cancel
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountOrigin) + " " + (selectedCurrency ? selectedCurrency : baseCurrency)}} </td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div v-if="selectedCard === 3" class="pt-4 px-4 my-4 mt-6" style="display: flex; justify-content: center; background-color: #fff4e5; flex-direction: row; border-radius: 15px;">
                    <div>
                      <v-icon color="rgb(237, 108, 2)" style="margin-right: 12px">mdi-alert-outline</v-icon>
                    </div>
                    <div>
                      <p style="font-size: 16px; font-weight: 700; color: rgb(102, 60, 0)">{{ 'Por favor carga los fondos correspondientes antes o en la fecha del vencimiento' }}</p>
                      <p style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                        {{ 'Si el pago no cuenta con los fondos para la fecha indicada' }} {{ 'En caso de no cumplir con el pago de la operación pactada, se deberá cubrir el diferencial entre la tipo de cambio de esa fecha y la pactada inicialmente.' }}
                      </p>
                      <v-checkbox v-model="checkboxModel" color="primary" hide-details class="pb-5">
                        <template v-slot:label>
                          <div style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                            {{ 'Necesitarás disponer el 5% de los fondos totales del Futuro ahora, el monto a depositar es de' }} <span style="font-size: 18px; font-weight: bold;">{{ totalAmountOrigin ? formatMoney(totalAmountOrigin * .5) + ' USD' : 'N/A' }}</span> {{ 'el monto se restará de tu balance origen.' }}
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn 
                    color="black"
                    elevation="8"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="e1 = 1, checkboxModel = false"
                  >
                    {{ 'Regresar' }}
                  </v-btn>
                  <v-btn 
                    color="black"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :disabled="selectedCard == 3 ? !checkboxModel || !allDatesSelected || !allRatesSelected || loadingCalculator : loadingCalculator || baseCurrency == 'USD' ? totalAmountOrigin > parseFloat(balanceUsd) : totalAmountOrigin > parseFloat(balanceMxn)"
                    @click="convertInvoice(), e1 = 3"
                  >
                    {{ 'Continuar' }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <v-stepper-content step="3" elevation="0" class="pt-0">
              <v-btn icon @click="getClient(), e1 = 1, selectedCard = null, selectedInvoice = [], dialogConvertInvoices = false" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-container class="mt-1">
                <div v-if="loadingConversion" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando conversion...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ "Conversion realizada correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al realizar la conversion!
                  </v-card-title>
                </div>
                <v-card-text class="pt-4 pb-0 px-0">
                  <v-simple-table>
                    <template v-if="loadingCalculator">
                        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
                    </template>
                    <template v-else>
                      <thead>
                        <tr>
                          <th>{{ 'Factura a convertir' }}</th>
                          <th>{{ 'Nombre del beneficiario' }}</th>
                          <th>{{ 'Número CLABE' }}</th>
                          <th>{{ 'Cantidad a origen' }}</th>
                          <th>{{ 'Cantidad a destino' }}</th>
                          <th>{{ 'Tipo de cambio' }}</th>
                          <th v-if="selectedCard === 3">Forward Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td>{{ invoice.sInvoice }}</td>
                          <td>{{ invoice.supplier }}</td>
                          <td>{{ "********" + invoice.sAccountNumber }}</td>
                          <td>${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td>${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td>${{ selectedCard == 2 ? formatMoney(invoice.dExchangeRate) : (invoice.dForwardExchangeRate ? formatMoney(invoice.dForwardExchangeRate) : "") }} MXN</td>
                          <td v-if="selectedCard === 3">
                            <v-dialog v-if="dialogConvert" ref="dialog" v-model="invoice.modal" width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn text :color="invoice.dForwardDate ? 'primary' : 'grey'" v-bind="attrs" v-on="on">
                                  {{ invoice.dForwardDate ? formatDate(invoice.dForwardDate) : "Select Date" }}
                                </v-btn>
                              </template>
                              <v-date-picker v-model="invoice.dForwardDate" :min="today" :allowed-dates="onlyWeekdays" :max="limit" scrollable @input="getForwardRate(invoice)">
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="closeDatePicker(invoice)"
                                  >
                                  Cancel
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountOrigin) + " " + (selectedCurrency ? selectedCurrency : baseCurrency)}} </td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div v-if="selectedCard === 3" class="pt-4 px-4 my-4 mt-6" style="display: flex; justify-content: center; background-color: #fff4e5; flex-direction: row; border-radius: 15px;">
                    <div>
                      <v-icon color="rgb(237, 108, 2)" style="margin-right: 12px">mdi-alert-outline</v-icon>
                    </div>
                    <div>
                      <p style="font-size: 16px; font-weight: 700; color: rgb(102, 60, 0)">{{ 'Por favor carga los fondos correspondientes antes o en la fecha del vencimiento' }}</p>
                      <p style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                        {{ 'Si el pago no cuenta con los fondos para la fecha indicada' }} {{ 'En caso de no cumplir con el pago de la operación pactada, se deberá cubrir el diferencial entre la tipo de cambio de esa fecha y la pactada inicialmente.' }}
                      </p>
                      <v-checkbox v-model="checkboxModel" color="primary" hide-details class="pb-5">
                        <template v-slot:label>
                          <div style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                            {{ 'Necesitarás disponer el 5% de los fondos totales del Futuro ahora, el monto a depositar es de' }} <span style="font-size: 18px; font-weight: bold;">{{ totalAmountOrigin ? formatMoney(totalAmountOrigin * .5) + ' USD' : 'N/A' }}</span> {{ 'el monto se restará de tu balance origen.' }}
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </v-card-text>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDialogAccountStatment" max-width="800px" max-height="600px" min-height="600px" persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center" style="background-color: #2D2D2D; border-radius: 10px; color: white;">
          <span class="title font-weight-bold text-textblack">
            {{ enterprise.enterprise?.enterprise[0]?.sName + " - " + monthsFull[selectedMonth] + " " + selectedYear }}
          </span>
          <v-btn icon @click="showDialogAccountStatment = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex justify-center align-center" style="border-radius: 10px; padding: 16px;">
            <span class="title font-weight-bold text-center" style="color: #737583;">
              {{ "Selecciona la fecha" }}
            </span>
          </div>
          <div class="d-flex justify-center align-center py-2" style="max-width: 250px; margin: 0 auto; gap: 10px;">
            <v-btn
              class="month-picker-btn"
              @click="showMonthPicker = true"
              elevation="0"
              block
              style="justify-content: space-between;"
            >
              <span class="month-picker-label">
                {{ monthsFull[selectedMonth] }}, {{ selectedYear }}
              </span>
              <v-icon color="#BDBDBD" right>mdi-calendar</v-icon>
            </v-btn>

            <v-dialog v-model="showMonthPicker" max-width="300px" persistent>
              <v-card>
                <v-card-text>
                  <div class="month-picker">
                    <div class="header">
                      <v-btn icon @click="prevYear"><v-icon>mdi-chevron-left</v-icon></v-btn>
                      <span class="year">{{ monthPickerYear }}</span>
                      <v-btn icon @click="nextYear"><v-icon>mdi-chevron-right</v-icon></v-btn>
                    </div>
                    <div class="months-grid">
                      <v-btn
                        v-for="(month, i) in monthsAbbr"
                        :key="i"
                        :color="selectedMonth === i && selectedYear === monthPickerYear ? 'black' : ''"
                        :class="{ 'selected': selectedMonth === i && selectedYear === monthPickerYear }"
                        @click="selectMonthModal(i)"
                        depressed
                        class="month-btn"
                        :disabled="isMonthDisabled(i)"
                      >
                        {{ month }}
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="justify-center pt-0 pb-4">
                  <v-btn text color="black" @click="showMonthPicker = false">Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-card-text>
        <div class="d-flex justify-center pb-4">
          <v-btn
            color="#000000"
            class="white--text"
            rounded
            @click="downloadStatement"
            :loading="loading"
          >
            Descargar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from "moment";
  import Users from "@/views/EnterpriseDetails/Users.vue";
  import Modules from "@/views/EnterpriseDetails/Modules.vue";
  import Spreads from "@/views/EnterpriseDetails/Spreads.vue";
  import Permissions from "@/views/EnterpriseDetails/Permissions.vue";
  import Alerts from "@/views/EnterpriseDetails/Alerts.vue";
  import Beneficiarios from "@/views/EnterpriseDetails/Beneficiarios.vue";
  import ConversionesActivas from "@/views/EnterpriseDetails/ConversionesActivas.vue";
  import ConversionesDisponibles from "@/views/EnterpriseDetails/ConversionesDisponibles.vue";
  import Conversions from "@/views/EnterpriseDetails/Conversions.vue";
  import Egresos from "@/views/EnterpriseDetails/Egresos.vue";
  import Facturas from "@/views/EnterpriseDetails/Facturas.vue";
  import FacturasMX from "@/views/EnterpriseDetails/FacturasMX.vue";
  import Ingresos from "@/views/EnterpriseDetails/Ingresos.vue";
  import Info from "@/views/EnterpriseDetails/Info.vue";
  import Documents from "@/views/EnterpriseDetails/Documents.vue";
  import Balances from "@/views/EnterpriseDetails/Balances.vue";
  import Movimientos from "@/views/EnterpriseDetails/Movimientos.vue";

  export default {
    components: {
      Users,
      Modules,
      Permissions,
      Spreads,
      Alerts,
      Beneficiarios,
      ConversionesDisponibles,
      ConversionesActivas,
      Conversions,
      Egresos,
      Facturas,
      FacturasMX,
      Movimientos,
      Ingresos,
      Info,
      Documents,
      Balances
    },
    name: "DashboardView",
    data() {
      return {
        createBeneficiary: false,
        dialogSelectAccountType: false,
        selectedAccountType: null,
        existingAccountType: null,
        accountTypes: [
          {
            id: 'retiro',
            title: 'Cuenta de retiro Banco',
            description: 'Crea una cuenta bancaria para retirar fondos de la plataforma.'
          },
          {
            id: 'window_spot_mxn',
            title: 'Cuenta para Window Spot',
            description: 'Crea una cuenta para recibir fondos en MXN desde Window Spot.'
          },
          {
            id: 'window_spot_usd',
            title: 'Cuenta para Window Spot',
            description: 'Crea una cuenta para recibir fondos en USD desde Window Spot.'
          }
        ],
        enterprise: {},
        activeAccounts: {
          retiro: false,
          mxn: false,
          usd: false
        },
        dialogAccountDetail: false,
        accountDetailType: null,
        accountDetailData: null,
        isLoadingAccountDetail: false,
        activePanel: null,
        comment: "",
        selectedCurrency: null,
        isLoading: false,
        selectedTypeOfPayment: null,
        selectedCard: null,
        selectedInvoice: [],
        conversionTypes: [
          { id: 2, name: "Spot" },
          { id: 3, name: "Forward" },
          { id: 4, name: "Window Spot" },
        ],
        selectedStatus: "453f47d8-d5ad-4159-be49-b48b0f04caa5",
        status: [
          { sName: "To pay", sStatusId: "453f47d8-d5ad-4159-be49-b48b0f04caa5" },
          { sName: "Converted", sStatusId: "904a91ab-bdfc-45dc-a72f-fc02c2a15005" },
          { sName: "Paid", sStatusId: "f42d5b71-bcc8-4c2c-997a-40ad2da2bc31" },
        ],
        loading: false,
        loadingPayment: false,
        paymentError: null,
        dialogWithdrawal: false,
        dialogConvert: false,
        dialogSendPay: false,
        dialogSendPayMassive: false,
        massPaymentOriginCurrency: null,
        massPaymentsRows: [],
        massPaymentLoading: false,
        massPaymentStep: 1,
        massPaymentSuccess: false,
        massPaymentResultMessage: '',
        massPaymentResults: [],
        massPaymentSuccessfulCount: 0,
        massPaymentFailedCount: 0,
        massPaymentTotalPayments: 0,
        acceptWarranty: false,
        company: null,
        e1: 1,
        currencyMap: {
          USD: { name: "Dólares Estadounidenses", flag: require("../../assets/images/Flags_usa.svg") },
          MXN: { name: "Pesos Mexicanos", flag: require("../../assets/images/Flags_mex.svg") },
        },
        avaibleAmount: null,
        amounts: { USD: 0, MXN: 0 },
        baseCurrency: "USD",
        targetCurrency: "MXN",
        exchangeRateToday: "",
        exchangeRateTodayReference: "",
        isLoadingRate: false,
        dDateForward: null,
        modal: false,
        forward: null,
        today: null,
        sortType: "asc",
        sortTypes: [
          { text: "Ascendente", value: "asc" },
          { text: "Descendente", value: "desc" },
        ],
        payDetail: {
          supplier: "",
          totalUSD: "",
          exchangeRate: "",
          dTotalAmount: "",
          sAccountNumber: "",
          exchangeRateToday: "",
          sInvoice: "",
        },
        tab: null,
        balanceMxn: "0",
        balanceUsd: "0",
        totalAmountOrigin: 0,
        totalAmountDest: 0,
        loadingCalculator: false,
        limitWindowSpot: null,
        limit: null,
        suppliers: [],
        selectedSupplier: null,
        selected: null,
        loadingConversion: false,
        conversionError: false,
        conversion: null,
        isLoadingAmount: false,
        dialogAddFounds: false,
        addFoundsCurrency: null,
        conversionsHistory: [],
        transactions: [],
        activeConversions: [],
        payments: [],
        invoices: [],
        incomes: [],
        alerts: [],
        paymentsRecipients: [],
        isLoadingFounds: false,
        dataAddFounds: {},
        supplier: null,
        currentDate: moment(),
        currentDateCdmx: moment().clone().utcOffset("-06:00"),
        isDisabledForward: false,
        isDisabledWindow: false,
        selectedDestCurrency: null,
        rules: {
          required: (v) => !!v || "El campo es obligatorio",
          clabeLength: (v) => (v && v.length === 18) || "La cuenta clabe debe tener exactamente 18 caracteres",
        },
        forms: {
          new: {
            sName: "",
            sEmail: "",
            sBank_name: "",
            sAccount_number: "",
            clabe: "",
            sCountry: "",
            currency: "",
            sTaxId: "",
            accountType: "",
            sState: "",
            sCity: "",
            sAddress: "",
            transferMethod: "",
          },
        },
        step: 1,
        country: ['MX', 'USA'],
        currency: ['MXN', 'USD'],
        accountType: [
          { text: 'CHECKING', value: '1' },
          { text: 'SAVINGS', value: '2' },
        ],
        transferMethod: [
          { id: 1, name: 'WIRE' },
          { id: 2, name: 'ACH' }
        ],
        dialogSendPayWithTransaction: false,
        sTransactionId: null,
        dialogRequestPayment: false,
        dialogCreateAlert: false,
        targetPrice: null,
        isLoadingAlertsCreate: false,
        forms: {
          new: {
            dPurchaseDate: "",
            sPaymentRecipientId: "",
            sInvoice: "",
            sId: "",
            dTotalAmount: "",
            dRateProtection: "",
            iCreditPeriod: "",
          }
        },
        dialogCreateInvoice: false,
        dialogPayInvoices: false,
        dialogConvertInvoices: false,
        selectCard: null,
        showDialogAccountStatment: false,
        selectedMonth: moment().month(),
        selectedYear: moment().year(),
        monthPickerYear: moment().year(),
        showMonthPicker: false,
        incomes: {
          USD: { list: [], total: 0 },
          MXN: { list: [], total: 0 },
        },
        payments: {
          USD: { list: [], total: 0 },
          MXN: { list: [], total: 0 },
        },
        aperturaReportadaUSD: 0,
        aperturaReportadaMXN: 0,
        isAutorized: false,
        isLoadingAutorized: false,
        refreshToken: 0,
      };
    },
    computed: {
      monthsAbbr() {
        moment.locale('es');
        return Array.from({ length: 12 }, (_, i) => {
          const abbr = moment().month(i).format('MMM');
          return abbr.charAt(0).toUpperCase() + abbr.slice(1);
        });
      },
      monthsFull() {
        moment.locale('es');
        return Array.from({ length: 12 }, (_, i) => {
          const full = moment().month(i).format('MMMM');
          return full.charAt(0).toUpperCase() + full.slice(1);
        });
      },
      isCurrentMonthSelected() {
        const now = moment();
        console.log(this.selectedMonth, this.selectedYear, now.month(), now.year());
        return this.selectedMonth === now.month() && this.selectedYear === now.year();
      },
      differenceUSD() {
        // ingresos - egresos + apertura - balance
        return (
          parseFloat(this.incomes?.USD?.total || 0) -
          parseFloat(this.payments?.USD?.total || 0) +
          parseFloat(this.aperturaReportadaUSD || 0)
        );
      },
      differenceMXN() {
        // ingresos - egresos + apertura - balance
        return (
          parseFloat(this.incomes?.MXN?.total || 0) -
          parseFloat(this.payments?.MXN?.total || 0) +
          parseFloat(this.aperturaReportadaMXN || 0)
        );
      },
      spreadValidation() {
        const exchangeRate = this.enterprise?.exchangeRate;
        const spread = parseFloat(this.enterprise?.enterprise?.spread);

        if (!exchangeRate?.mxnRate || !exchangeRate?.usdRate || isNaN(spread)) {
          return { valid: null, configuredSpread: null };
        }

        const { mxnRate, usdRate, midRate } = exchangeRate;
        const tolerance = 0.001;
        const spreadFraction = spread / 100;

        if (!midRate || !isFinite(midRate) || midRate <= 0) {
          return { valid: null, midRate: null, configuredSpread: spread.toFixed(4) };
        }

        const impliedSpreadVenta = (midRate - mxnRate) / midRate;
        const impliedSpreadCompra = (usdRate - midRate) / midRate;

        return {
          valid: Math.abs(impliedSpreadVenta - spreadFraction) <= tolerance &&
                 Math.abs(impliedSpreadCompra - spreadFraction) <= tolerance,
          midRate,
          impliedSpreadVenta: (impliedSpreadVenta * 100).toFixed(4),
          impliedSpreadCompra: (impliedSpreadCompra * 100).toFixed(4),
          configuredSpread: spread.toFixed(4),
        };
      },
      massPaymentTotalOrigin() {
        return this.massPaymentsRows.reduce((sum, row) => {
          const value = parseFloat(row.originAmount || 0);
          return sum + (Number.isFinite(value) ? value : 0);
        }, 0);
      },
      massPaymentTotalDest() {
        return this.massPaymentsRows.reduce((sum, row) => {
          const value = parseFloat(row.destAmount || 0);
          return sum + (Number.isFinite(value) ? value : 0);
        }, 0);
      },
      canSubmitMassPayment() {
        if (!this.massPaymentOriginCurrency || this.massPaymentsRows.length === 0) {
          return false;
        }
        return this.massPaymentsRows.every((row) => {
          const hasSupplier = !!row.supplier;
          const validAmounts = parseFloat(row.originAmount || 0) > 0 && parseFloat(row.destAmount || 0) > 0;
          const requiresExchange = row.supplier && row.supplier.sAccountCurrency !== this.massPaymentOriginCurrency;
          const hasRate = !requiresExchange || (!!row.exchangeRateReference && !!row.exchangeRateToday);
          const hasConcept = !!row.comment;
          return hasSupplier && validAmounts && hasRate && hasConcept;
        });
      },
    },
    methods: {
      async openCreateAccountFlow() {
        // Cerrar el diálogo de selección
        this.dialogSelectAccountType = false;

        // Abrir el flujo de creación de beneficiario
        this.createBeneficiary = true;

        // Hardcodear valores por defecto según el tipo de cuenta
        if (this.selectedAccountType === 'retiro') {
          // Cuenta retiro - siempre MXN, México
          this.forms.new.currency = 'MXN';
          this.forms.new.sCountry = 'MX';

          // Si hay cuenta existente, pre-cargar datos
          if (this.activeAccounts.retiro) {
            await this.preloadAccountData('retiro');
          }
        } else if (this.selectedAccountType === 'window_spot_mxn') {
          // Window spot MXN - siempre MXN, México
          this.forms.new.currency = 'MXN';
          this.forms.new.sCountry = 'MX';

          if (this.activeAccounts.mxn) {
            await this.preloadAccountData('mxn');
          }
        } else if (this.selectedAccountType === 'window_spot_usd') {
          // Window spot USD - siempre USD, USA
          this.forms.new.currency = 'USD';
          this.forms.new.sCountry = 'USA';

          if (this.activeAccounts.usd) {
            await this.preloadAccountData('usd');
          }
        }
      },
      async preloadAccountData(accountType) {
        try {
          const response = await DB.get(
            `${URI}/api/v1/en/administrator/client/${this.$route.params.sEnterpriseId}/account-detail/${accountType}`,
            {
              headers: {
                Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
              }
            }
          );

          const account = response.data.account;

          this.forms.new.sName = account.sName;
          this.forms.new.sEmail = account.sEmail;
          this.forms.new.sBank_name = account.sBankName;
          this.forms.new.clabe = account.sAccountNumber;
          this.forms.new.sTaxId = account.sTaxId;

          if (accountType === 'usd') {
            this.forms.new.sAccount_number = account.sAccountNumber;
            this.forms.new.routingNumber = account.sRoutingNumber;
            this.forms.new.accountType = account.sAccountType;
            this.forms.new.transferMethod = account.sTransferMethod;
            this.forms.new.sAddress = account.sAddressLine;
            this.forms.new.sCity = account.sCity;
            this.forms.new.sState = account.sState;
            this.forms.new.postCode = account.postCode;
          }

          this.existingAccountType = accountType;
        } catch (error) {
          console.error('Error loading account data:', error);
        }
      },
      async getClient() {
        this.isLoading = true;
        const current = ++this.refreshToken;

        try {
          const resp = await DB.get(
            `${URI}/api/v1/en/administrator/client/${this.$route.params.sEnterpriseId}`,
            {
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              }
            }
          );

          if (current !== this.refreshToken) return;
          this.enterprise = resp.data.enterprise;
          this.balanceMxn = this.enterprise.balance?.balanceMxn?.balance;
          this.balanceUsd = this.enterprise.balance?.balanceUsd?.balance;
          this.company = resp.data.paymentRecipient;
          this.permissionList = resp.data.permissionList;

          // Obtener cuentas activas
          this.getActiveAccounts();
        } catch (error) {
          if (error?.response?.data?.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error?.response?.data?.message, error?.response?.status);
        } finally {
          if (current === this.refreshToken) this.isLoading = false;
        }
      },
      async onWalletsUpdate() {
        await this.getClient();
      },
      async getActiveAccounts() {
        try {
          const response = await DB.get(
            `${URI}/api/v1/en/administrator/client/${this.$route.params.sEnterpriseId}/active-accounts`,
            {
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              }
            }
          );
          this.activeAccounts = response.data.activeAccounts;
        } catch (error) {
          console.error('Error fetching active accounts:', error);
        }
      },
      async openAccountDetail(accountType) {
        this.dialogAccountDetail = true;
        this.accountDetailType = accountType;
        this.isLoadingAccountDetail = true;
        this.accountDetailData = null;

        try {
          const response = await DB.get(
            `${URI}/api/v1/en/administrator/client/${this.$route.params.sEnterpriseId}/account-detail/${accountType}`,
            {
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              }
            }
          );
          this.accountDetailData = response.data.account;
        } catch (error) {
          console.error('Error fetching account detail:', error);
          this.mixError(error?.response?.data?.message || 'Error al obtener detalle de cuenta', error?.response?.status);
        } finally {
          this.isLoadingAccountDetail = false;
        }
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      getSuppliers() {
        this.isLoadingSuppliers = true;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/suppliers`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            this.isLoadingSuppliers = false;
            this.suppliers = response.data.paymentRecipients;
            this.suppliers.map((item) => {
              item.sNameAC = item.sName + " - *******" + (item.sAccountNumber ? item.sAccountNumber.slice(-4) : item.accountNumber.slice(-4)) + " - (" + item.sAccountCurrency + ")";
            });
          })
          .catch((error) => {
            this.isLoadingSuppliers = false;
            this.mixError(error.response.data.message, error.response.status);
          });
      },
      onlyWeekdays(date) {
        const day = new Date(date).getDay();
        return day !== 5 && day !== 6;
      },
      swapCurrencies() {
        [this.baseCurrency, this.targetCurrency] = [this.targetCurrency, this.baseCurrency];
        this.amounts = { USD: 0, MXN: 0 };
        if (this.selectedCard === 3) {
          this.dDateForward = null;
        }
        this.getRate(this.baseCurrency, this.targetCurrency);
      },
      async getRate(originCurrency, destCurrency) {
        this.isLoadingRate = true;
        this.exchangeRateToday = null;
        this.exchangeRateTodayReference = null;
        this.amounts = { USD: 0, MXN: 0 };

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          currency: originCurrency,
          desCurrency: destCurrency,
        };

        if (originCurrency != destCurrency) {
          DB.post(`${URI}/api/v1/en/administrator/getExchangeRate`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          })
          .then((response) => {
            this.exchangeRateToday = response.data.exchangeRateToday;
            this.exchangeRateTodayReference = response.data.exchangeRateTodayReference;
            this.mixSuccess(response.data.message);
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          })
          .finally(() => {
            this.isLoadingRate = false;
          });
        }
      },
      async calculatorAmount(amount, reverse, currency, desCurrency) {
        this.isLoadingRate = true;
        let rate = this.exchangeRateTodayReference;
        this.reverseCalculator = reverse;

        const payload = {
          amount: amount,
          rate: rate,
          reverse: this.reverseCalculator,
          sEnterpriseId: this.$route.params.sEnterpriseId
        };

        try {
          DB.post(`${URI}/api/v1/en/administrator/calculatorAmount`, payload, {
            headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : "",
              },
          })
          .then((response) => {
            const result = parseFloat(response.data.data.result);
            this.exchangeRateToday = response.data.data.rate;
            this.amounts[this.reverseCalculator ? currency : desCurrency] = this.roundHalfEven(result, 2).toFixed(2);
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          })
          .finally(() => {
            this.isLoadingRate = false;
          });
        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
        }
      },
      async getForwardRate(amount, reverse) {
        this.isLoadingRate = true;

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          dDateForward: this.dDateForward,
          dAmount: amount,
          referenceExchangeRate: this.exchangeRateTodayReference,
          reverse: reverse
        };
        try {
          DB.post(`${URI}/api/v1/en/administrator/forwardRate`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          })
          .then((response) => {
            this.exchangeRateToday = response.data.forwardRate.rate;
            this.rateForwardReference = response.data.forwardRate.uuid;
            if (amount > 0) {
              this.warranty = response.data.forwardRate.initial_percentage_amount;
              if (reverse) {
                this.amounts[this.baseCurrency] = response.data.forwardRate.result;
              } else {
                this.amounts[this.targetCurrency] = response.data.forwardRate.result;
              }
            }
            this.reverseCalculator = reverse;
            this.mixSuccess(response.data.message);
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          })
          .finally(() => {
            this.isLoadingRate = false;
          });
        } catch (error) {
          this.mixError(
            error.response?.data?.message || "Error desconocido",
            error.response?.status || 500
          );
          throw error;
        }
      },
      async createConversion() {
        this.loadingConversion = true;
        this.conversionError = null;

        let sTransactionType = "";
        if (this.selectedCard === 2) {
          sTransactionType = "e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a";
        } else if (this.selectedCard === 3) {
          sTransactionType = "b80e8dc6-4138-449e-8903-968efb8437b3";
        } else if (this.selectedCard === 4) {
          sTransactionType = "484a23d2-7dc1-4fd0-a1b0-3402d066c2cf";
        }

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          sTransactionType: sTransactionType,
          dOriginCurrency: this.baseCurrency,
          dDestCurrency: this.targetCurrency,
          dOriginAmount: parseFloat(this.amounts[this.baseCurrency]),
          dDestAmount: parseFloat(this.amounts[this.targetCurrency]),
          dExchangeRate: this.exchangeRateToday,
          referenceExchangeRate: this.exchangeRateTodayReference,
          bExternal: false,
          dForwardTransactionDate: this.dDateForward,
          reverse: this.reverseCalculator,
          dPercentageAmount: this.warranty || null,
          rateForwardReference: this.rateForwardReference || null,
        };

        try {
          const response = await DB.post(
            `${URI}/api/v1/en/administrator/createConversion`,
            payload,
            { headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""}}
          );
          this.mixSuccess(response.data.message);
          this.conversion = response.data.transaction;
          this.conversionError = false;
        } catch (error) {
          this.conversionError = true;
          this.mixError(error.response.data.message, error.response.status);
        } finally {
          this.loadingConversion = false;
        }
      },
      openModalAddFounds(currency) {
        this.dialogAddFounds = true;
        this.addFoundsCurrency = currency;
        this.isLoadingFounds = true;
        this.dataAddFounds = {};

        const payload = {
          currency: currency,
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/addFounds`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            this.dataAddFounds = response.data.account;
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          })
          .finally(() => {
            this.isLoadingFounds = false;
          });
      },
      roundHalfEven(num, decimals = 2) {
        const factor = Math.pow(10, decimals);
        const temp = num * factor;
        const floor = Math.floor(temp);
        const diff = temp - floor;

        if (diff === 0.5) {
          return (floor % 2 === 0 ? floor : floor + 1) / factor;
        }

        return Math.round(temp) / factor;
      },
      checkTime() {
        this.currentTime = this.currentDate.format("MMMM DD, YYYY, HH:mm:ss [GMT]Z");
        this.currentTimeCdmx = this.currentDateCdmx.format(
          "MMMM DD, YYYY, HH:mm:ss [GMT-6]"
        );
        const currentHourCdmx = this.currentDateCdmx.hour();
        const currentDayCdmx = this.currentDateCdmx.day();
        if (currentDayCdmx === 6 || currentDayCdmx === 0) {
          this.isDisabledForward = true;
        } else if (currentHourCdmx >= 9 && currentHourCdmx < 16) {
          this.isDisabledForward = false;
        } else {
          this.isDisabledForward = true;
        }
        if (currentDayCdmx === 6 || currentDayCdmx === 0) {
          this.isDisabledWindow = true;
        }
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      isConversionDisabled(item) {
        if (item.name === "Forward") return this.isDisabledForward;
        if (item.name === "Window Spot") return this.isDisabledWindow;
        return false;
      },
      async sendPayment() {
        this.loadingPayment = true;
        this.paymentError = null;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          dOriginAmount: this.amounts[this.selectedCurrency],
          dDestAmount: this.amounts[this.supplier?.sAccountCurrency],
          dOriginCurrency: this.selectedCurrency,
          dDestCurrency: this.supplier?.sAccountCurrency,
          comment: this.comment,
          sPaymentRecipientId: this.supplier?.sPaymentRecipientId,
          sExchangeRateReference: this.exchangeRateTodayReference,
          reverse: this.reverseCalculator,
          selectedTypeOfPayment: this.selectedTypeOfPayment,
          sTransactionId: this.sTransactionId ? [this.sTransactionId] : []
        };

        try {
          const response = await DB.post(
            `${URI}/api/v1/en/administrator/createPayment`,
            payload,
            { headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""}}
          );
          this.mixSuccess(response.data.message);
          this.payment = response.data.payment;
          this.paymentError = false;
        } catch (error) {
          this.paymentError = true;
          this.mixError(error.response.data.message, error.response.status);
        } finally {
          this.loadingPayment = false;
        }
      },
      openMassPaymentDialog() {
        this.dialogSendPayMassive = true;
        this.massPaymentOriginCurrency = null;
        this.massPaymentsRows = [];
        this.massPaymentsRows.push(this.createMassPaymentRow());
        this.massPaymentLoading = false;
        this.getSuppliers();
      },
      createMassPaymentRow() {
        return {
          id: `row-${Date.now()}-${Math.floor(Math.random() * 10000)}`,
          supplier: null,
          originAmount: 0,
          destAmount: 0,
          exchangeRateToday: null,
          exchangeRateReference: '',
          selectedTypeOfPayment: null,
          comment: '',
          loadingRate: false,
        };
      },
      selectMassPaymentCurrencyUSD() {
        this.massPaymentOriginCurrency = 'USD';
        this.massPaymentsRows = [];
        this.massPaymentsRows.push(this.createMassPaymentRow());
      },
      selectMassPaymentCurrencyMXN() {
        this.massPaymentOriginCurrency = 'MXN';
        this.massPaymentsRows = [];
        this.massPaymentsRows.push(this.createMassPaymentRow());
      },
      addMassPaymentRow() {
        const limit = 10;
        if (this.massPaymentsRows.length < limit) {
          this.massPaymentsRows.push(this.createMassPaymentRow());
        } else {
          this.mixError(`No puedes agregar más de ${limit} filas.`, 400);
        }
      },
      removeMassPaymentRow(index) {
        if (this.massPaymentsRows.length > 1) {
          this.massPaymentsRows.splice(index, 1);
        }
      },
      onMassPaymentSupplierChange(row) {
        if (!row.supplier) {
          row.originAmount = 0;
          row.destAmount = 0;
          row.exchangeRateToday = null;
          row.exchangeRateReference = '';
          row.selectedTypeOfPayment = null;
          return;
        }
        row.originAmount = 0;
        row.destAmount = 0;
        row.exchangeRateToday = null;
        row.exchangeRateReference = '';
        row.selectedTypeOfPayment = null;
      },
      async getRateForMassRow(row) {
        if (!this.massPaymentOriginCurrency || !row.supplier) {
          return;
        }

        row.loadingRate = true;
        row.exchangeRateToday = null;
        row.exchangeRateReference = '';
        row.originAmount = 0;
        row.destAmount = 0;

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          currency: this.massPaymentOriginCurrency,
          desCurrency: row.supplier.sAccountCurrency,
        };

        try {
          const response = await DB.post(`${URI}/api/v1/en/administrator/getExchangeRate`, payload, {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
            },
          });
          row.exchangeRateToday = response.data.exchangeRateToday;
          row.exchangeRateReference = response.data.exchangeRateTodayReference;
          this.mixSuccess(response.data.message);
        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
        } finally {
          row.loadingRate = false;
        }
      },
      async calculatorAmountForMassRow(row, amount, reverse) {
        if (!row.exchangeRateReference || !this.massPaymentOriginCurrency) {
          return;
        }

        row.loadingRate = true;
        const payload = {
          amount,
          rate: row.exchangeRateReference,
          reverse,
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        try {
          const response = await DB.post(`${URI}/api/v1/en/administrator/calculatorAmount`, payload, {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
            },
          });
          const result = parseFloat(response.data.data.result);
          const rounded = this.roundHalfEven(result, 2).toFixed(2);
          if (reverse) {
            row.originAmount = rounded;
          } else {
            row.destAmount = rounded;
          }
        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
        } finally {
          row.loadingRate = false;
        }
      },
      async sendMassPayment() {
        this.massPaymentLoading = true;
        this.massPaymentSuccess = false;
        this.massPaymentResultMessage = '';

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          payments: this.massPaymentsRows.map((row) => ({
            sPaymentRecipientId: row.supplier.sPaymentRecipientId,
            dOriginAmount: parseFloat(row.originAmount),
            dDestAmount: parseFloat(row.destAmount),
            dOriginCurrency: this.massPaymentOriginCurrency,
            dDestCurrency: row.supplier.sAccountCurrency,
            comment: row.comment,
            sExchangeRateReference: row.exchangeRateReference,
            reverse: row.supplier.sAccountCurrency !== this.massPaymentOriginCurrency,
            selectedTypeOfPayment: "Spot",
            beneficiaryName: row.supplier.sName,
          })),
        };

        try {
          const response = await DB.post(`${URI}/api/v1/en/administrator/createMassPayment`, payload, {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
            },
          });
          this.massPaymentSuccess = true;
          this.massPaymentResultMessage = response.data.message || 'Todos los pagos se procesaron correctamente.';
          this.massPaymentFailedCount = response.data.failedCount || 0;
          this.massPaymentResults = response.data.results || [];
          this.mixSuccess(this.massPaymentResultMessage);
        } catch (error) {
          this.massPaymentSuccess = false;
          this.massPaymentResultMessage = error.response?.data?.message || 'Error al procesar los pagos.';
          this.massPaymentResults = error.response?.data?.results || [];
          this.mixError(this.massPaymentResultMessage, error.response?.status);
        } finally {
          this.massPaymentLoading = false;
        }
      },
      async proceedWithMassPayment() {
        this.massPaymentStep = 3;
        await this.sendMassPayment();
      },
      resetMassPaymentDialog() {
        this.dialogSendPayMassive = false;
        this.massPaymentOriginCurrency = null;
        this.massPaymentsRows = [];
        this.massPaymentLoading = false;
        this.massPaymentStep = 1;
        this.massPaymentSuccess = false;
        this.massPaymentResultMessage = '';
      },
      openDetail(item) {
        this.$router.push({
          name: "PaymentDetail",
          params: { sPaymentId: item.sPaymentId }
        }).catch(() => {});
      },
      getReceipt(item) {
        this.loading = true;
        const payload = {
          sPaymentId: item.sPaymentId,
          sEnterpriseId: item.sEnterpriseId,
        };

        DB.post(
          `${URI}/api/v1/en/administrator/getReceipt`, payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            },
            responseType: 'blob'
          }
        )
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${item.PaymentRecipient + (item.invoice ? "_" + item.invoice : "")}.pdf`;
          link.click();
        })
        .catch((error) => {
          this.mixError(
            error?.response?.data?.message || "No se pudo descargar el archivo",
            error?.response?.status || 500
          );
        })
        .finally(() => {
          this.loading = false;
        });
      },
      getCep(item) {
        this.loading = true;
        const payload = {
          sPaymentId: item.sPaymentId,
          sEnterpriseId: item.sEnterpriseId,
        };

        DB.post(
          `${URI}/api/v1/en/administrator/getCep`, payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        )
        .then((response) => {
          const url = response.data.paymentCep;
          if (url) {
            window.open(url, "_blank");
          } else {
            this.mixError("Error al descargar el cep.", 400);
          }
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.loading = false;
        });
      },
      async toggleSelect(item) {
        const alreadySelected = this.isSelected(item);
        const destCurrency = item.paymentsRecipent[0].sAccountCurrency;

        if (alreadySelected) {
          this.selectedInvoice = this.selectedInvoice.filter(
            (selectedItem) => selectedItem.sInvoiceId !== item.sInvoiceId
          );

          if (this.selectedInvoice.length === 0) {
            this.selectedDestCurrency = null;
          }

          return;
        }

        if (this.selectedInvoice.length === 0) {
          this.selectedDestCurrency = destCurrency;
          this.selectedInvoice.push(item);
          return;
        }

        if (this.selectedInvoice.length >= 20) {
          this.mixWarning("Solo puedes seleccionar hasta 20 facturas.");
          return;
        }

        if (this.selectedDestCurrency !== destCurrency) {
          this.mixWarning("Solo puedes seleccionar facturas con la misma moneda destino.");
          return;
        }

        this.selectedInvoice.push(item);
      },
      isSelected(item) {
        return this.selectedInvoice.some(
          (selectedItem) => selectedItem.sInvoiceId === item.sInvoiceId
        );
      },
      async getInvoices() {
        this.selectedInvoice = [];
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          sPaymentRecipientId: this.selectedSupplier,
          sStatusId: this.selectedStatus,
        };
        DB.post(`${URI}/api/v1/en/administrator/client/invoices`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            this.invoices = response.data.invoices;
          })
          .catch((error) => {
            this.isLoadingSuppliers = false;
            this.mixError(error, 400);
          });
      },
      nextStep() {
        if (this.$refs.formNew) {
          const isValid = this.$refs.formNew.validate();

          if (isValid) {
            this.step = 2;
          }
        }
      },
      async saveWithdrawalAccount() {
        if (this.$refs.formNew.validate()) {
          this.loading = true;

          const payload = {
            sEnterpriseId: this.$route.params.sEnterpriseId,
            sName: this.forms.new.sName,
            sEmail: this.forms.new.sEmail,
            sBankName: this.forms.new.sBank_name,
            clabe: this.forms.new.clabe
          };

          DB.post(
              `${URI}/api/v1/en/administrator/client/create-withdrawal-account`,
              payload,
              {
                headers: {
                  Authorization: this.$store.state.sToken
                    ? `Bearer ${this.$store.state.sToken}`
                    : ""
                }
              }
            )
          .then((response) => {
            this.loading = false;
            this.getSuppliers();
            this.step = 1;
            this.forms.new = {
              sName: "",
              sEmail: "",
              sBank_name: "",
              sAccount_number: "",
              clabe: "",
              sCountry: "",
              currency: "",
              sTaxId: "",
              accountType: "",
              sState: "",
              sCity: "",
              sAddress: "",
              transferMethod: "",
            };
            this.getClient();
            this.createBeneficiary = false;
            this.selectedAccountType = null;
            this.existingAccountType = null;
            this.mixSuccess(response.data.message);
          })
          .catch((error) => {
            this.loading = false;
            this.mixError(error.response.data.message, error.response.status);
          });
        } else {
          this.error = true;
          this.codeError = "INVALID_INPUT";
        }
      },
      async saveWindowMXNAccount() {
        if (this.$refs.formNew.validate()) {
          this.loading = true;

          const payload = {
            sEnterpriseId: this.$route.params.sEnterpriseId,
            sName: this.forms.new.sName,
            sEmail: this.forms.new.sEmail,
            sBankName: this.forms.new.sBank_name,
            clabe: this.forms.new.clabe
          };

          DB.post(
              `${URI}/api/v1/en/administrator/client/create-window-mxn-account`,
              payload,
              {
                headers: {
                  Authorization: this.$store.state.sToken
                    ? `Bearer ${this.$store.state.sToken}`
                    : ""
                }
              }
            )
          .then((response) => {
            this.loading = false;
            this.getSuppliers();
            this.step = 1;
            this.forms.new = {
              sName: "",
              sEmail: "",
              sBank_name: "",
              sAccount_number: "",
              clabe: "",
              sCountry: "",
              currency: "",
              sTaxId: "",
              accountType: "",
              sState: "",
              sCity: "",
              sAddress: "",
              transferMethod: "",
            };
            this.getClient();
            this.createBeneficiary = false;
            this.selectedAccountType = null;
            this.existingAccountType = null;
            this.mixSuccess(response.data.message);
          })
          .catch((error) => {
            this.loading = false;
            this.mixError(error.response.data.message, error.response.status);
          });
        } else {
          this.error = true;
          this.codeError = "INVALID_INPUT";
        }
      },
      async saveWindowUSDAccount() {
        if (this.$refs.formNew.validate()) {
          this.loading = true;

          const payload = {
            sEnterpriseId: this.$route.params.sEnterpriseId,
            name: this.forms.new.sName,
            email: this.forms.new.sEmail,
            bank_name: this.forms.new.sBank_name,
            sAccountNumber: this.forms.new.sAccount_number,
            routingNumber: this.forms.new.routingNumber,
            transferMethod: String(this.forms.new.transferMethod),
            accountType: String(this.forms.new.accountType),
            sCity: this.forms.new.sCity,
            sState: this.forms.new.sState,
            sAddress: this.forms.new.sAddress,
            postCode: this.forms.new.postCode
          };

          DB.post(
              `${URI}/api/v1/en/administrator/client/create-window-usd-account`,
              payload,
              {
                headers: {
                  Authorization: this.$store.state.sToken
                    ? `Bearer ${this.$store.state.sToken}`
                    : ""
                }
              }
            )
          .then((response) => {
            this.loading = false;
            this.getSuppliers();
            this.step = 1;
            this.forms.new = {
              sName: "",
              sEmail: "",
              sBank_name: "",
              sAccount_number: "",
              clabe: "",
              sCountry: "",
              currency: "",
              sTaxId: "",
              accountType: "",
              sState: "",
              sCity: "",
              sAddress: "",
              transferMethod: "",
              postCode: "",
            };
            this.getClient();
            this.createBeneficiary = false;
            this.selectedAccountType = null;
            this.existingAccountType = null;
            this.mixSuccess(response.data.message);
          })
          .catch((error) => {
            this.loading = false;
            this.mixError(error.response.data.message, error.response.status);
          });
        } else {
          this.error = true;
          this.codeError = "INVALID_INPUT";
        }
      },
      async saveBeneficiary() {
        if (this.$refs.formNew.validate()) {
          this.loading = true;

          let payload = {
              sEnterpriseId: this.$route.params.sEnterpriseId,
              sName: this.forms.new.sName,
              sEmail: this.forms.new.sEmail,
              sBankName: this.forms.new.sBank_name,
              clabe: this.forms.new.clabe,
              sAccountNumber: this.forms.new.sAccount_number,
              sEntityBusiness: "COMPANY",
              sTaxId: this.forms.new.sTaxId,
              accountType: this.forms.new.accountType,
              sState: this.forms.new.sState,
              sCity: this.forms.new.sCity,
              sCountry: this.forms.new.sCountry,
              sAddress: this.forms.new.sAddress,
              transferMethod: this.forms.new.transferMethod,
              currency: this.forms.new.currency,
              routingNumber: this.forms.new.routingNumber,
          };

          DB.post(
              `${URI}/api/v1/en/administrator/createBeneficiary`,
              payload,
              {
                headers: {
                  Authorization: this.$store.state.sToken
                    ? `Bearer ${this.$store.state.sToken}`
                    : ""
                }
              }
            )
          .then((response) => {
            this.loading = false;
            this.getSuppliers();
            this.step = 1;
            this.forms.new = {
              sName: "",
              sEmail: "",
              sBank_name: "",
              sAccount_number: "",
              clabe: "",
              sCountry: "",
              currency: "",
              sTaxId: "",
              accountType: "",
              sState: "",
              sCity: "",
              sAddress: "",
              transferMethod: "",
            };
            this.getClient();
            this.createBeneficiary = false;
            this.mixSuccess(response.data.message);
          })
          .catch((error) => {
            this.loading = false;
            this.mixError(error.response.data.message, error.response.status);
          });
        } else {
          this.error = true;
          this.codeError = "INVALID_INPUT";
        }
      },
      async requestPayment() {
        this.loading = true;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          sTransactionId: this.forward.sTransactionId,
        };

        DB.post(
          `${URI}/api/v1/en/administrator/requestPayment`,
          payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        )
        .then((response) => {
          this.getClient();
          this.forward = null;
          this.dialogRequestPayment = false;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.forward = null;
          this.dialogRequestPayment = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      createAlert() {
        this.isLoadingAlertsCreate = true;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          dAmount: this.targetPrice,
          dAmountSpot: this.exchangeRateToday,
          sType: "8e574e88-2670-469e-b96e-7091082d82b9"
        };
        DB.post(`${URI}/api/v1/en/administrator/createAlert`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.mixSuccess(response.data.message);
          this.getClient();
          this.isLoadingAlertsCreate = false;
          this.dialogCreateAlert = false;
          this.targetPrice = null;
        })
        .catch((error) => {
          this.isLoadingAlertsCreate = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      createInvoice() {
        if (this.$refs.formNew.validate()) {
          this.loading = true;
          let payload = {
            sEnterpriseId: this.$route.params.sEnterpriseId,
            dPurchaseDate: this.forms.new.dPurchaseDate,
            sPaymentRecipientId: this.forms.new.sSupplier.sPaymentRecipientId,
            sInvoice: this.forms.new.sInvoice,
            sId: this.forms.new.sId,
            dTotalAmount: this.forms.new.dTotalAmount,
            dRateProtection: this.forms.new.dRateProtection,
            iCreditPeriod: this.forms.new.iCreditPeriod,
            contactData: {
              create: false,
            },
          };

          DB.post(`${URI}/api/v1/en/administrator/createInvoice`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          })
            .then((response) => {
              this.loading = false;
              this.mixSuccess(response.data.message);
              this.getClient();
              this.dialogCreateInvoice = false;
            })
            .catch((error) => {
              this.loading = false;
              this.mixError(error.response.data.message, error.response.status);
            });
        } else {
          this.error = true;
          this.codeError = "INVALID_INPUT";
        }
      },
      async openPayNow(items) {
        this.loadingCalculator = true;
        this.totalAmountOrigin = 0;
        this.totalAmountDest = 0;

        const originCurrency = this.selectedCurrency ? this.selectedCurrency : this.baseCurrency;

        this.payDetail.invoices = await Promise.all(items.map(async (item) => {
          const destCurrency = item.paymentsRecipent[0].sAccountCurrency;
          let dOriginAmount = item.dTotalAmount;
          let sExchangeRateReference = null;
          let exchangeRateToday = null;

          if (originCurrency !== destCurrency) {
            const payload = {
              sEnterpriseId: this.$route.params.sEnterpriseId,
              currency: originCurrency,
              desCurrency: destCurrency,
            };

            const response = await DB.post(`${URI}/api/v1/en/administrator/getExchangeRate`, payload, {
              headers: {
                Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
              }
            });
            exchangeRateToday = response.data.exchangeRateToday;
            sExchangeRateReference = response.data.exchangeRateTodayReference;
            dOriginAmount = await this.calculatorAmountInvoice(item.dTotalAmount, sExchangeRateReference);
          }

          return {
            sInvoiceId: item.sInvoiceId,
            supplier: item.sName,
            sInvoice: item.sInvoice,
            dExchangeRate: exchangeRateToday,
            sAccountNumber: (item.paymentsRecipent[0].accountNumber ? item.paymentsRecipent[0].accountNumber.slice(-4) : item.paymentsRecipent[0].sAccountNumber.slice(-4)),
            dOriginAmount,
            dDestAmount: item.dTotalAmount,
            sExchangeRateReference,
            originCurrency,
            destCurrency,
            sPaymentRecipientId: item.sPaymentRecipientId,
            reverse: originCurrency !== destCurrency
          };
        }));

        // Calcular totales
        this.totalAmountOrigin = Math.ceil(
          this.payDetail.invoices.reduce((sum, invoice) => sum + parseFloat(invoice.dOriginAmount), 0) * 100
        ) / 100;

        this.totalAmountDest = this.payDetail.invoices.reduce(
          (sum, invoice) => sum + parseFloat(invoice.dDestAmount),
          0
        );

        this.loadingCalculator = false;
      },
      async payInvoice() {
        this.loadingPayment = true;
        this.paymentError = null;

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          invoices: this.payDetail.invoices.map(invoice => ({
            sInvoiceId: invoice.sInvoiceId,
            sInvoice: invoice.sInvoice,
            dOriginAmount: invoice.dOriginAmount,
            dDestAmount: invoice.dDestAmount,
            sPaymentRecipientId: invoice.sPaymentRecipientId,
            originCurrency: invoice.originCurrency,
            destCurrency: invoice.destCurrency,
            sExchangeRateReference: invoice.sExchangeRateReference,
            reverse: invoice.reverse
          })),
          originCurrency: this.selectedCurrency,
          paymentType: 'Spot',
          sortDirection: this.sortType,
        };

        try {
          const response = await DB.post(`${URI}/api/v1/en/administrator/payInvoices`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          });

          this.mixSuccess(response.data.message, response.data.status);
          this.paymentError = false;
        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
          this.paymentError = true
        } finally {
          this.loadingPayment = false;
        }
      },
      async calculatorAmountInvoice(amount, rate) {
        const headers = {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        }
        try {
          const response = await DB.post(`${URI}/api/v1/en/administrator/calculatorAmount`, {
            amount: amount,
            rate: rate,
            reverse: true
          }, { headers });
          return this.roundHalfEven(response.data.data.result, 2).toFixed(2);
        } catch (error) {
          return null;
        }
      },
      async convertInvoice() {
        this.loadingConversion = true;
        this.paymentError = null
        
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          invoices: this.payDetail.invoices.map(invoice => ({
            sInvoiceId: invoice.sInvoiceId,
            sInvoice: invoice.sInvoice,
            dOriginAmount: invoice.dOriginAmount,
            dDestAmount: invoice.dDestAmount,
            dExchangeRate: invoice.dExchangeRate,
            sPaymentRecipientId: invoice.sPaymentRecipientId,
            originCurrency: invoice.originCurrency,
            destCurrency: invoice.destCurrency,
            sExchangeRateReference: invoice.sExchangeRateReference,
            reverse: invoice.reverse
          })),
          sTransactionType: this.selectedCard === 2 ? 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a' : 'b80e8dc6-4138-449e-8903-968efb8437b3',
          dOriginCurrency: this.baseCurrency,
          dDestCurrency: this.targetCurrency
        };

        try {
          const response = await DB.post(`${URI}/api/v1/en/administrator/convertInvoices`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          });

          this.mixSuccess(response.data.message, response.data.status);
          this.paymentError = false
        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
          this.paymentError = true
        } finally {
          this.loadingConversion = false;
        }
      },
      openModalAccountStatment() {
        this.showDialogAccountStatment = true;
        this.getAccountData({ month: this.selectedMonth, year: this.monthPickerYear });
      },
      selectMonthModal(monthIdx) {
        this.selectedMonth = monthIdx;
        this.selectedYear = this.monthPickerYear;
        this.showMonthPicker = false;
        this.getAccountData({ month: monthIdx, year: this.monthPickerYear });
      },
      async getAccountData({ month, year }) {
        const date = moment().month(month).year(year).format('YYYY-MM');

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          date: date,
        };

        try {
          const response = await DB.post(`${URI}/api/v1/en/administrator/getIncomesAndPaymentsByEnterprise`, payload, {
            headers: {
               Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""}
          });

          if(response.data?.data?.statements?.length > 0) {
            this.isAutorized = true;
          } else {
            this.isAutorized = false;
          }

          const incomesByCurrency = { USD: [], MXN: [] };
          (response.data.data.incomes || []).forEach(income => {
            if (income.sCurrency === 'USD') {
              incomesByCurrency.USD.push(income);
            } else if (income.sCurrency === 'MXN') {
              incomesByCurrency.MXN.push(income);
            }
          });

          const paymentsByCurrency = { USD: [], MXN: [] };
          (response.data.data.payments || []).forEach(payment => {
            if (payment.sCurrency && paymentsByCurrency[payment.sCurrency]) {
              paymentsByCurrency[payment.sCurrency].push(payment);
            }
          });

          this.incomes = {
            USD: {
              list: incomesByCurrency.USD,
              total: incomesByCurrency.USD.reduce((acc, income) => acc + parseFloat(income.dAmount || 0), 0)
            },
            MXN: {
              list: incomesByCurrency.MXN,
              total: incomesByCurrency.MXN.reduce((acc, income) => acc + parseFloat(income.dAmount || 0), 0)
            }
          };

          this.payments = {
            USD: {
              list: paymentsByCurrency.USD,
              total: paymentsByCurrency.USD.reduce((acc, payment) => acc + parseFloat(payment.dPaymentAmount || 0), 0)
            },
            MXN: {
              list: paymentsByCurrency.MXN,
              total: paymentsByCurrency.MXN.reduce((acc, payment) => acc + parseFloat(payment.dPaymentAmount || 0), 0)
            }
          };

        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
        } finally {
          this.isLoadingIncomes = false;
        }
      },
      prevYear() {
        this.monthPickerYear--;
      },
      nextYear() {
        this.monthPickerYear++;
      },
      isMonthDisabled(monthIdx) {
        const now = moment();
        if (this.monthPickerYear > now.year()) return true;
        if (this.monthPickerYear < now.year()) return false;
        // Permitir el mes actual (monthIdx > now.month() en vez de >=)
        return monthIdx > now.month();
      },
      async autorizeAccountStatement() {
        this.isLoadingAutorized = true;
        const month = (this.selectedMonth + 1).toString().padStart(2, '0');
        const statments = [
          {
            date: this.selectedYear + '-' + month,
            sWallet: 'USD',
            dAmount: this.aperturaReportadaUSD
          },
          {
            date: this.selectedYear + '-' + month,
            sWallet: 'MXN',
            dAmount: this.aperturaReportadaMXN
          }
        ]
        const payload = {
          sEnterpriseId: this.$route.params.id,
          statments: statments
        };

        console.log('payload', payload);

        try {
          const response = await DB.post(
            `${URI}/api/v1/en/administrator/autorizeAccountStatement`,
            payload,
            {
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              }
            }
          );

          if(response.data.success) {
            this.getAccountData({ month: this.selectedMonth, year: this.monthPickerYear });
            this.mixSuccess('Estado de cuenta autorizado correctamente');
          } else {
            this.mixError(response.data.message, response.data.status);
          }
        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
        } finally {
          this.loading = false;
          this.isLoadingAutorized = false;
        }
      },
      async downloadStatement() {
        this.loading = true;
        const month = (this.selectedMonth + 1).toString().padStart(2, '0');
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          date: this.selectedYear + '-' + month
        };

        try {
          const response = await DB.post(
            `${URI}/api/v1/en/administrator/getAccountStatement`,
            payload,
            {
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              },
              responseType: "arraybuffer"
            }
          );

          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `Estado_de_cuenta_${this.enterprise.enterprise?.enterprise[0]?.sName || 'empresa'}_${this.selectedYear}-${month}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
        } finally {
          this.loading = false;
        }
      }
    },
    beforeMount() {
      this.getClient();
      this.checkTime();
      this.paymentDay = moment().format("YYYY-MM-DD");
      this.today = moment().add(1, "day").format("YYYY-MM-DD");
      this.limitWindowSpot = moment().add(7, "day").format("MMMM DD, YYYY");
      this.limitWindowSpot = moment().add(7, "day").format("MMMM DD, YYYY");
      this.limit = moment(this.today).add(1, "year").format("YYYY-MM-DD");
    },
    beforeDestroy() {
    },
  };
</script>

<style scoped>
.text-return {
  font-family: "montserrat-medium";
}

.info-card {
  border: 1px #bbbbbb solid;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35) !important;
  background-color: white;
  border-radius: 20px !important;;
  padding: 16px;
}

.info-block {
  background-color: #F2F2F2;
  border-radius: 10px !important;
  padding: 8px;
  margin-bottom: 10px;
}

.label {
  color: #868DA6;
  font-family: "montserrat-bold";
  font-size: 14px;
  margin-bottom: 2px;
  padding: 5px 5px;
  width: fit-content;
  display: flex;
  align-items: center;
}

.value {
  color: black;
  font-family: "montserrat-bold";
  font-size: 16px;
  padding: 5px 5px;
  margin-bottom: 2px;
  width: fit-content;
  display: flex;
  align-items: center;
}

.account-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 5px;
}

.account-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.account-label {
  color: black;
  font-family: "montserrat-medium";
  font-size: 14px;
}

.account-type-card {
  position: relative;
  transition: all 0.3s ease;
}

.account-type-card:hover {
  border-color: #000 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.account-type-card.selected {
  border-color: #000 !important;
  background-color: #F5F5F5 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

.profit-text {
  color: black;
}

.amount-text {
  font-size: 22px;
  color: black;
  font-family: "montserrat-bold";
}

.action-btn {
  border-radius: 36px;
  font-family: "montserrat-semibold";
  text-transform: none;
  border: 2px solid #0075BB;
}

.action-btn.primary {
  background-color: black;
  color: white;
}

.v-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-expansion-panel:not(:first-child)::after {
  border-top: none !important;
}

.title-card {
  font-family: "montserrat-regular";
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0%;
  color: #737583;
}
.value-card {
  font-family: "montserrat-bold";
  font-weight: 600;
  font-size: 26px;
  line-height: 120%;
  letter-spacing: 0%;
  color: #2D2D2D;
}

.month-picker {
  width: 220px;
  background: #fff;
  border-radius: 12px;
  padding: 12px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 8px;
}
.months-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.month-btn.selected {
  background: black !important;
  color: white !important;
}
.month-btn {
  min-width: 0;
  font-weight: bold;
  text-transform: none;
}
.year {
  width: 60px;
  text-align: center;
}
.month-picker-btn {
  background: #F9FAFD !important;
  border-radius: 12px !important;
  color: #989A9B !important;
  font-weight: 400 !important;
  font-family: 'montserrat-regular', sans-serif;
  min-height: 44px;
  max-width: 50px;
  text-transform: none;
  box-shadow: none !important;
  border: none !important;
  cursor: pointer;
}
.month-picker-label {
  color: #989A9B;
  font-size: 18px;
  font-weight: 400;
  font-family: 'montserrat-regular', sans-serif;
}
.text-date {
  font-family: montserrat-regular;
  font-size: 11px;
  font-weight: 500;
  line-height: 120%;
  color: #BBBBBE;
}
.text-amount {
  font-family: montserrat-bold;
  font-size: 12px;
  line-height: 120%;
  color: #2D2D2D;
}
.scrollable-card-content {
  overflow-y: auto;
  max-height: 350px;
}

</style>
